// Generated by Avo VERSION 211.9.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "rHXH41ZY5fXuixTtBmEL";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "rMU8KiqnNXMp0QbZmCll",
          "br": "-Tp80h5X89GUCAgNBTyi5",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "7JBjRhWGgpbREMm61E1Y",
          "se": (new Date()).toISOString(),
          "so": "votbEGr9_ZZB8Y_DPd8mm",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "rMU8KiqnNXMp0QbZmCll",
          "br": "-Tp80h5X89GUCAgNBTyi5",
          "en": env,
          "ty": type,
          "sc": "7JBjRhWGgpbREMm61E1Y",
          "se": (new Date()).toISOString(),
          "so": "votbEGr9_ZZB8Y_DPd8mm",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "7JBjRhWGgpbREMm61E1Y",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export const SegmentSourceType = {
  'API': 'api',
  'BROWSER': 'browser',
  'SERVER': 'server',
} as const;
export type SegmentSourceTypeType = typeof SegmentSourceType;
export type SegmentSourceTypeValueType = SegmentSourceTypeType[keyof SegmentSourceTypeType];

export const OriginView = {
  'ABOUT': 'About',
  'ADD_MULTIPLE_TASKS': 'Add Multiple Tasks',
  'ADMINS': 'Admins',
  'ALLOCATION': 'Allocation',
  'APPROVALS': 'Approvals',
  'ASSIGNMENTS': 'Assignments',
  'ATTACHED_FILES': 'Attached Files',
  'AVAILABILITY': 'Availability',
  'BOARD': 'Board',
  'BULK_ACTION_COMPLETE': 'Bulk Action Complete',
  'BULK_ACTION_IN_PROGRESS': 'Bulk Action In Progress',
  'CALENDAR': 'Calendar',
  'CAPACITY': 'Capacity',
  'CHANGES': 'Changes',
  'CHANGES_BY_ME': 'Changes by me',
  'CONFIGURATION': 'Configuration',
  'CONFIGURATION_GENERAL': 'Configuration - General',
  'CONFIGURATION_SHARING': 'Configuration - Sharing',
  'CONNECTIONS': 'Connections',
  'COST_REPORT': 'CostReport',
  'DASHBOARD_REPORTS': 'Dashboard & Reports',
  'DASHBOARD_GUESTS': 'Dashboard Guests',
  'DAY': 'Day',
  'DAY_VIEW': 'Day View',
  'DAYS': 'Days',
  'DEFINE_LEVELS': 'Define Levels',
  'DELETED_ITEMS': 'Deleted Items',
  'DEV_NOTES': 'Dev Notes',
  'DISCONNECTED_USERS': 'Disconnected Users',
  'DISCOVER': 'Discover',
  'DISCUSSION': 'Discussion',
  'EMPTY_STATE': 'Empty State',
  'EVERYONE_TIME_OFF': 'Everyone Time Off',
  'EXPENSES': 'Expenses',
  'FEEDBACK_MODE_COMPLETED': 'Feedback Mode Completed',
  'FEEDBACK_MODE_FINAL_MODAL': 'Feedback Mode Final Modal',
  'FEEDBACK_MODE_STARTED': 'Feedback Mode Started',
  'FILE': 'File',
  'GLOBAL': 'Global',
  'GLOBAL_BILLING_RATES': 'Global Billing Rates',
  'GLOBAL_COST_RATES': 'Global Cost Rates',
  'GRID': 'Grid',
  'GROUP_ACCESS': 'Group Access',
  'GROUPS': 'Groups',
  'GUEST_ACCESS': 'Guest Access',
  'GUEST_PROFILE': 'Guest Profile',
  'HUD_VIEW': 'Hud View',
  'IMPORT_TASKS_FROM_EXCEL': 'Import Tasks from Excel',
  'INBOX_VIEW': 'Inbox View',
  'INDIVIDUAL': 'Individual',
  'INTEGRATIONS': 'Integrations',
  'INVITE_GUEST': 'Invite Guest',
  'ISSUE_PICKER_VIEW': 'Issue Picker View',
  'ISSUE_PASSED_TIME_BY_RESOLUTION': 'IssuePassedTimeByResolution',
  'ISSUE_PASSED_TIME_BY_STATUS': 'IssuePassedTimeByStatus',
  'ISSUE_TIME': 'IssueTime',
  'ISSUE_TIME_BALANCE': 'IssueTimeBalance',
  'ISSUE_WORKED_TIME_BY_LABEL': 'IssueWorkedTimeByLabel',
  'ISSUE_WORKED_TIME_BY_STATUS': 'IssueWorkedTimeByStatus',
  'ISSUE_WORKED_TIME_BY_USER': 'IssueWorkedTimeByUser',
  'LAYOUT': 'Layout',
  'LIBRARY': 'Library',
  'LICENSED_USERS': 'Licensed Users',
  'LIST': 'List',
  'MEMBERS': 'Members',
  'MONTH': 'Month',
  'MONTHS': 'Months',
  'MY_WORK': 'My Work',
  'NAMING': 'Naming',
  'NATIVE_DIALOG': 'Native Dialog',
  'NOTES': 'Notes',
  'ORGANIZATION': 'Organization',
  'OVERVIEW': 'Overview',
  'PENDING_INVITES': 'Pending Invites',
  'PERMISSION_OVERVIEW': 'Permission Overview',
  'PERSONAL': 'Personal',
  'PERSONAL_TIME_OFF': 'Personal Time Off',
  'PIE_CHART': 'PieChart',
  'PLAN_APPROVAL_OVERLAY': 'Plan Approval Overlay',
  'PLAN_ITEMS': 'Plan Items',
  'PORTFOLIO': 'Portfolio',
  'PROFILE': 'Profile',
  'PROFILES': 'Profiles',
  'PROJECT': 'Project',
  'PROJECT_ACCESS': 'Project Access',
  'PROPERTIES': 'Properties',
  'QA_NOTES': 'QA Notes',
  'QUARTERS': 'Quarters',
  'REVIEW_ALL_WORKLOGS_COMPLETED': 'Review All Worklogs Completed',
  'REVIEW_ALL_WORKLOGS_STARTED': 'Review All Worklogs Started',
  'ROADMAP_ITEM_CARD': 'Roadmap Item Card',
  'ROADMAP_SWIMLANE': 'Roadmap Swimlane',
  'ROADMAP_TABLE_VIEW': 'Roadmap Table View',
  'ROADMAP_TIMELINE': 'Roadmap Timeline',
  'ROLES_RULES': 'Roles & Rules',
  'ROLES_AND_RULES': 'Roles and Rules',
  'ROLES_AND_RULES_ACCESS': 'Roles and Rules Access',
  'SCHEDULE': 'Schedule',
  'SCHEDULING': 'Scheduling',
  'SCOPE': 'Scope',
  'SEARCH': 'Search',
  'SELECT_MODE': 'Select Mode',
  'SELECT_PROJECT': 'Select Project',
  'SET_UP_CI': 'Set Up CI',
  'SET_UP_TIMESHEETS': 'Set Up Timesheets',
  'SETTINGS': 'Settings',
  'SETTINGS_FILTER': 'Settings & Filter',
  'SETTINGS_FILTERS': 'Settings & Filters',
  'SETTINGS_VIEW': 'Settings View',
  'SINGLE_PROJECT_VIEW': 'Single Project View',
  'SUMMARY': 'Summary',
  'TASK_BOARD': 'Task Board',
  'TEAM': 'Team',
  'TEMPO_VIEW': 'Tempo View',
  'TIME': 'Time',
  'TIME_BALANCE': 'TimeBalance',
  'TIME_ENTRY': 'TimeEntry',
  'TIME_TRACKING': 'TimeTracking',
  'TIMELINE': 'Timeline',
  'TIMESHEET': 'Timesheet',
  'TIMESPENT': 'Timespent',
  'TRACKER_LIST_VIEW': 'Tracker List View',
  'TRACKER_UPDATE_VIEW': 'Tracker Update View',
  'WEEK': 'Week',
  'WEEK_VIEW': 'Week View',
  'WEEKS': 'Weeks',
  'WELCOME_SCREEN': 'Welcome screen',
  'WORKING_TIMES': 'Working Times',
  'WORKLOAD': 'Workload',
  'WORKSPACE_ACCESS': 'Workspace Access',
  'ADMINISTRATIVE_GROUPS': 'Administrative Groups',
  'WORKING_TEAMS': 'Working Teams',
  'ACCESS_TOKENS_HISTORY': 'Access Tokens History',
  'DATA_SOURCES_HISTORY': 'Data Sources History',
  'EXPORT_HISTORY': 'Export History',
  'SYSTEM_FIELDS': 'System fields',
  'CUSTOM_FIELDS': 'Custom fields',
  'DEPENDENCIES': 'Dependencies',
  'BY_ALL_WORK_ITEMS': 'By all work Items',
  'BY_MISSING_DATA': 'By missing data',
  'BY_RISK_TYPE': 'By risk type',
  'DELIVERABLES': 'Deliverables',
  'PROGRESS': 'Progress',
  'TAKE_ACTION_PANEL': 'Take Action Panel',
  'ITEM_DETAILS_PANEL': 'Item Details Panel',
  'INVESTMENT_BALANCE': 'Investment Balance',
} as const;
export type OriginViewType = typeof OriginView;
export type OriginViewValueType = OriginViewType[keyof OriginViewType];

export const PanelName = {
  'PRIMARY': 'Primary',
  'SECONDARY': 'Secondary',
  'NEEDS_ATTENTION': 'Needs attention',
  'DEPENDENCY_ANALYSIS': 'Dependency analysis ',
  'MISSING_DATA': 'Missing data',
} as const;
export type PanelNameType = typeof PanelName;
export type PanelNameValueType = PanelNameType[keyof PanelNameType];

export const OriginProduct = {
  'BASE': 'Base',
  'CAPACITY_INSIGHTS': 'Capacity Insights',
  'CAPACITY_PLANNER': 'Capacity Planner',
  'COST_TRACKER': 'Cost Tracker',
  'CUSTOM_CHARTS_FOR_CONFLUENCE': 'Custom Charts for Confluence',
  'CUSTOM_CHARTS_FOR_JIRA': 'Custom Charts for Jira',
  'FINANCIAL_MANAGER': 'Financial Manager',
  'INTERACT_EVERYWHERE': 'Interact Everywhere',
  'LIQUID_PLANNER': 'Liquid Planner',
  'MOBILE': 'Mobile',
  'PLANNER': 'Planner',
  'ROADMUNK': 'Roadmunk',
  'STRUCTURE': 'Structure',
  'STRUCTURE_GANTT': 'Structure Gantt',
  'STRUCTURE_PI_PLANNER': 'Structure PI Planner',
  'TEMPO_CORE': 'Tempo Core',
  'TEMPO_PROJECTS': 'Tempo Projects',
  'TEMPO_TRACKER': 'Tempo Tracker',
  'TIME_REPORTS': 'Time Reports',
  'TIMESHEET_REPORTS_AND_GADGETS': 'Timesheet Reports and Gadgets',
  'TIMESHEETS': 'Timesheets',
  'BIGQUERY_CONNECTOR_FOR_JIRA': 'BigQuery Connector for Jira',
  'LOOKER_STUDIO_CONNECTOR_FOR_JIRA': 'Looker Studio Connector for Jira',
  'POWER_BI_CONNECTOR_FOR_JIRA': 'Power BI Connector for Jira',
  'SQL_CONNECTOR_FOR_JIRA': 'SQL Connector for Jira',
  'TABLEAU_CONNECTOR_FOR_JIRA': 'Tableau Connector for Jira',
  'SPM': 'SPM',
} as const;
export type OriginProductType = typeof OriginProduct;
export type OriginProductValueType = OriginProductType[keyof OriginProductType];

export const OriginPage = {
  '_INSIGHTS_HUB': ' Insights Hub',
  'API': 'API',
  'API_INTEGRATION': 'API Integration',
  'ACADEMY': 'Academy',
  'ACADEMY_TRACK': 'Academy - Track',
  'ACADEMY_HOME': 'Academy Home',
  'ACCEPT_INVITATION': 'Accept Invitation',
  'ACCESS': 'Access',
  'ACCESS_CONTROL': 'Access Control',
  'ACCOUNT_BILLING_RATES': 'Account Billing Rates',
  'ACCOUNT_OVERVIEW': 'Account Overview',
  'ACCOUNT_TIMESHEET': 'Account Timesheet',
  'ACCOUNTS_IMPORT_EXPORT': 'Accounts Import/Export',
  'ACCOUNTS_OVERVIEW': 'Accounts Overview',
  'ACTIVITY_FEED_CONFIGURATION': 'Activity Feed Configuration',
  'ADD_MEMBER': 'Add Member',
  'ADMINISTRATION': 'Administration',
  'ALL_PROJECTS': 'All Projects',
  'ALL_PROJECTS_SEARCH': 'All Projects - Search',
  'ALL_USERS': 'All Users',
  'ALL_USERS_INVITE': 'All Users - Invite',
  'ARCHIVED': 'Archived',
  'ARCHIVED_DASHBOARD': 'Archived - Dashboard',
  'ARCHIVED_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Changes Widget Click-through',
  'ARCHIVED_DASHBOARD_DESIGN': 'Archived - Dashboard - Design',
  'ARCHIVED_DASHBOARD_DESIGN_GUEST_ACCESS_INVITE': 'Archived - Dashboard - Design - Guest Access - Invite',
  'ARCHIVED_DASHBOARD_INTAKE_SETTINGS': 'Archived - Dashboard - Intake - Settings',
  'ARCHIVED_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Intake Widget Click-through',
  'ARCHIVED_DASHBOARD_LIST_GRID_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - List Grid Widget Click-through',
  'ARCHIVED_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Metrics Widget Click-through',
  'ARCHIVED_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Note Widget Click-through',
  'ARCHIVED_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Task Board Widget Click-through',
  'ARCHIVED_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Archived - Dashboard - Workload Widget Click-through',
  'ARCHIVED_REPORT': 'Archived - Report',
  'ARCHIVED_REPORT_DESIGN': 'Archived - Report - Design',
  'AUDIT_LOG': 'Audit Log',
  'AVAILABILITY': 'Availability',
  'BILLING_RATES': 'Billing Rates',
  'BILLING_RATES_TABLE': 'Billing Rates Table',
  'BITBUCKET_INTEGRATION': 'Bitbucket Integration',
  'BOARD': 'Board',
  'BOARD_SIDEBAR': 'Board Sidebar',
  'BULK_EDIT': 'Bulk Edit',
  'BULK_TIME_RECORDS_EDITOR': 'Bulk Time Records Editor',
  'CALENDAR_INTEGRATION': 'Calendar Integration',
  'CAPACITY': 'Capacity',
  'CAPACITY_ALLOCATION': 'Capacity - Allocation',
  'CAPACITY_INSIGHTS_OPERATION_DASHBOARD': 'Capacity Insights Operation Dashboard',
  'CATEGORIES_OVERVIEW': 'Categories Overview',
  'CHANGES': 'Changes',
  'COLLECTIONS': 'Collections',
  'COMPANY_REPORT': 'Company Report',
  'CONFLUENCE_MACRO': 'Confluence macro',
  'CONFLUENCE_MACRO_EDIT': 'Confluence macro edit',
  'CONSOLIDATED_REPORT': 'Consolidated Report',
  'COST_RATES': 'Cost Rates',
  'CUSTOM_FIELD_EXPORT_CONFIGURATION': 'Custom Field Export Configuration',
  'CUSTOMER_OVERVIEW': 'Customer Overview',
  'CUSTOMER_REPORT': 'Customer Report',
  'CUSTOMERS_OVERVIEW': 'Customers Overview',
  'DASHBOARD': 'Dashboard',
  'DASHBOARD_CREATE': 'Dashboard - Create',
  'DASHBOARD_GUEST_ACCESS': 'Dashboard - Guest Access',
  'DASHBOARD_GUEST_ACCESS_WIDGET_CLICK_THROUGH_VIEW': 'Dashboard - Guest Access - Widget Click-through View',
  'DASHBOARDS': 'Dashboards',
  'DATA_RETENTION': 'Data Retention',
  'DISCONNECTED_USER_RESTART_ACCOUNT': 'Disconnected User - Restart Account',
  'DISCONNECTED_USER_LOGIN': 'Disconnected User Login',
  'EDIT_PANEL': 'Edit Panel',
  'EMAIL_CONFIRMATION': 'Email Confirmation',
  'EXPIRED_EMAIL_CONFIRMATION': 'Expired Email Confirmation',
  'EXTENSION_BOARDS': 'Extension boards',
  'EXTENSION_GANTT_CONFLUENCE_MACRO': 'Extension gantt Confluence macro',
  'EXTENSION_GANTT_CONFLUENCE_MACRO_EDIT': 'Extension gantt Confluence macro edit',
  'EXTENSION_GANTT_DASHBOARD': 'Extension gantt dashboard',
  'EXTERNAL_PAGE': 'External Page',
  'FAVORITES': 'Favorites',
  'FORGOT_PASSWORD': 'Forgot Password',
  'GADGET': 'Gadget',
  'GET_STARTED': 'Get Started',
  'GET_STARTED_ADMIN': 'Get Started Admin',
  'GITHUB_INTEGRATION': 'GitHub Integration',
  'GITLAB_INTEGRATION': 'GitLab Integration',
  'GLOBAL_CONFIGURATION_BILLING_RATE': 'Global Configuration Billing Rate',
  'GLOBAL_CONFIGURATION_COST_RATE': 'Global Configuration Cost Rate',
  'GLOBAL_RATES_MOVED': 'Global Rates Moved',
  'GLOBAL_SETTINGS': 'Global Settings',
  'GLOBAL_SETTINGS_BILLING_RATES': 'Global Settings Billing Rates',
  'GLOBAL_SETTINGS_COST_RATES': 'Global Settings Cost Rates',
  'GOOGLE_CALENDAR_INTEGRATION': 'Google Calendar Integration',
  'GRID': 'Grid',
  'GROUP': 'Group',
  'GROUP_ROLES_AND_RULES_ACCESS': 'Group - Roles and Rules Access',
  'GUEST_PASSPORTS': 'Guest Passports',
  'GUEST_PROFILE': 'Guest Profile',
  'HISTORY_BULK_ACTIONS': 'History Bulk Actions',
  'HOLIDAY_SCHEME_CONFIGURATION': 'Holiday Scheme Configuration',
  'HOLIDAY_SCHEME_MEMBERS': 'Holiday Scheme Members',
  'HOLIDAY_SCHEMES': 'Holiday Schemes',
  'HOME': 'Home',
  'HOME_ACCOUNT_FIELDS': 'Home Account Fields',
  'HOME_ALL_FIELDS': 'Home All Fields',
  'HOME_ROADMAP_FIELDS': 'Home Roadmap Fields',
  'IDENTITY_SERVICE': 'Identity Service',
  'INSTALLATION_FAILURE_PAGE': 'Installation Failure Page',
  'INSTALLATION_PAGE': 'Installation Page',
  'INSTALLATION_SUCCESS_PAGE': 'Installation Success Page',
  'INTEGRATIONS': 'Integrations',
  'INTERNAL_ISSUES': 'Internal Issues',
  'ISSUE_HISTORY': 'Issue History',
  'JIRA_MOBILE_APP': 'JIRA Mobile App',
  'JIRA_INTEGRATION': 'Jira Integration',
  'JIRA_ISSUE_SEARCH': 'Jira Issue Search',
  'JIRA_ISSUE_VIEW': 'Jira Issue View',
  'JIRA_DASHBOARD_ITEM': 'Jira dashboard item',
  'LEGACY_TEAM_CAPACITY_REPORT': 'Legacy Team Capacity Report',
  'LIBRARY': 'Library',
  'LOGGED_TIME_REPORT': 'Logged Time Report',
  'LOGGING_WORK_CONFIGURATION': 'Logging Work Configuration',
  'LOGIN': 'Login',
  'LOGOUT': 'Logout',
  'MAINTENANCE': 'Maintenance',
  'MANAGE': 'Manage',
  'MANAGE_ACCOUNT': 'Manage Account',
  'MANAGE_ACCOUNT_DOWNGRADE': 'Manage Account - Downgrade',
  'MANAGE_ACCOUNT_UPGRADE': 'Manage Account - Upgrade',
  'MANAGE_STAFF': 'Manage Staff',
  'MESSAGES': 'Messages',
  'MISSING_INFORMATION': 'Missing Information',
  'MY_DISCUSSIONS': 'My Discussions',
  'MY_FAVORITES': 'My Favorites',
  'MY_WORK': 'My Work',
  'MY_WORK_APPROVALS': 'My Work Approvals',
  'MY_WORK_AVAILABILITY': 'My Work Availability',
  'MY_WORK_CHANGES': 'My Work Changes',
  'MY_WORK_SEARCH': 'My Work Search',
  'N_A': 'N/A',
  'OFFICE_365_INTEGRATION': 'Office 365 Integration',
  'ORGANIZATION_HUB_USERS_INTEGRATIONS': 'Organization Hub - Users - Integrations',
  'ORGANIZATION_HUB_USERS_INTEGRATIONS_SLACK_ADMIN': 'Organization Hub - Users - Integrations - Slack - Admin',
  'ORGANIZATION_USER_PROFILE': 'Organization User Profile',
  'OVERRIDE_MODE': 'Override Mode',
  'PACKAGE': 'Package',
  'PACKAGE_CAPACITY': 'Package - Capacity',
  'PACKAGE_DASHBOARD': 'Package - Dashboard',
  'PACKAGE_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Package - Dashboard - Changes Widget Click-through',
  'PACKAGE_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLIC_THROUGH': 'Package - Dashboard - Dashboard Note Widget Clic-through',
  'PACKAGE_DASHBOARD_DESIGN': 'Package - Dashboard - Design',
  'PACKAGE_DASHBOARD_DESIGN_INVITE_GUEST': 'Package - Dashboard - Design - Invite Guest',
  'PACKAGE_DASHBOARD_GRID_WIDGET_CLICK_THROUGH': 'Package - Dashboard - Grid Widget Click-through',
  'PACKAGE_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Package - Dashboard - Intake Widget Click-through',
  'PACKAGE_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Package - Dashboard - Intake Widget Settings',
  'PACKAGE_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Package - Dashboard - Metrics Widget Click-through',
  'PACKAGE_REPORT_DESIGN': 'Package - Report - Design',
  'PENDING': 'Pending',
  'PENDING_CHANGES': 'Pending - Changes',
  'PENDING_DASHBOARD': 'Pending - Dashboard',
  'PENDING_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Changes Widget Click-through',
  'PENDING_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Dashboard Note Widget Click-through',
  'PENDING_DASHBOARD_DESIGN': 'Pending - Dashboard - Design',
  'PENDING_DASHBOARD_DESIGN_GUEST_ACCESS_INVITE': 'Pending - Dashboard - Design - Guest Access - Invite',
  'PENDING_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Intake Widget Click-through',
  'PENDING_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Pending - Dashboard - Intake Widget Settings',
  'PENDING_DASHBOARD_LIST_GRID_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - List Grid Widget Click-through',
  'PENDING_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Metrics Widget Click-through',
  'PENDING_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Task Board Widget Click-through',
  'PENDING_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Pending - Dashboard - Workload Widget Click-through',
  'PENDING_GRID': 'Pending - Grid',
  'PENDING_REPORT': 'Pending - Report',
  'PENDING_REPORT_DESIGN': 'Pending - Report - Design',
  'PENDING_REPORT_DESIGN_SETTINGS': 'Pending - Report - Design - Settings',
  'PENDING_SEARCH': 'Pending - Search',
  'PEOPLE': 'People',
  'PEOPLE_ADD_PLACEHOLDER': 'People - Add Placeholder',
  'PEOPLE_ADD_RESOURCE': 'People - Add Resource',
  'PEOPLE_GROUP': 'People - Group',
  'PEOPLE_MEMBER_PROFILE': 'People - Member Profile',
  'PEOPLE_MEMBER_PROFILE_TASK_BOARD': 'People - Member Profile - Task Board',
  'PEOPLE_MEMBER_PROFILE_WORKLOAD': 'People - Member Profile - Workload',
  'PEOPLE_PLACEHOLDER_PROFILE': 'People - Placeholder Profile',
  'PEOPLE_RESOURCE_PROFILE': 'People - Resource Profile',
  'PERIOD_CONFIGURATION': 'Period Configuration',
  'PERIOD_MANAGEMENT': 'Period Management',
  'PERMISSION_OVERVIEW': 'Permission Overview',
  'PERMISSION_ROLES': 'Permission Roles',
  'PLANNED_TIME_REPORT': 'Planned Time Report',
  'PLANNED_VS_ACTUAL_REPORT': 'Planned vs Actual Report',
  'PLANNER_CROSS_SELL': 'Planner Cross Sell',
  'PLANNING_TIME_CONFIGURATION': 'Planning Time Configuration',
  'PORTABLE_ACADEMY': 'Portable Academy',
  'PORTABLE_ACADEMY_LESSON': 'Portable Academy Lesson',
  'PORTABLE_COURSE': 'Portable Course',
  'PORTABLE_DASHBOARD': 'Portable Dashboard',
  'PORTABLE_ITEM': 'Portable Item',
  'PORTABLE_ITEM_LIBRARY': 'Portable Item Library',
  'PORTABLE_LIBRARY': 'Portable Library',
  'PORTABLE_LIBRARY_ITEM_DASHBOARD': 'Portable Library Item Dashboard',
  'PORTABLE_MANAGE_ACCOUNT': 'Portable Manage Account',
  'PORTABLE_REPORT': 'Portable Report',
  'PORTFOLIO': 'Portfolio',
  'PORTFOLIO_CONFIGURATION_GENERAL': 'Portfolio Configuration General',
  'PORTFOLIO_CONFIGURATION_SHARING': 'Portfolio Configuration Sharing',
  'PORTFOLIO_LIST': 'Portfolio List',
  'PORTFOLIO_NOT_FOUND': 'Portfolio Not Found',
  'PORTFOLIO_SUMMARY': 'Portfolio Summary',
  'PORTFOLIO_TIMELINE': 'Portfolio Timeline',
  'PRINT_REPORT': 'Print Report',
  'PRODUCT_AREA': 'Product Area',
  'PROFILE': 'Profile',
  'PROFILES': 'Profiles',
  'PROGRAMS_OVERVIEW': 'Programs Overview',
  'PROJECT': 'Project',
  'PROJECT_ADD_TASKS': 'Project - Add Tasks',
  'PROJECT_DASHBOARD': 'Project - Dashboard',
  'PROJECT_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Changes Widget Click-through',
  'PROJECT_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Dashboard Note Widget Click-through',
  'PROJECT_DASHBOARD_DESIGN': 'Project - Dashboard - Design',
  'PROJECT_DASHBOARD_DESIGN_INVITE_GUEST': 'Project - Dashboard - Design - Invite Guest',
  'PROJECT_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Intake Widget Click-through',
  'PROJECT_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Project - Dashboard - Intake Widget Settings',
  'PROJECT_DASHBOARD_LIST_WIDGET_CLICK_THROUGH': 'Project - Dashboard - List Widget Click-through',
  'PROJECT_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Metrics Widget Click-through',
  'PROJECT_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Task Board Widget Click-through',
  'PROJECT_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Project - Dashboard - Workload Widget Click-through',
  'PROJECT_LIBRARY': 'Project - Library',
  'PROJECT_REPORT': 'Project - Report',
  'PROJECT_REPORT_DESIGN': 'Project - Report - Design',
  'PROJECT_APPROVALS_OVERVIEW': 'Project Approvals Overview',
  'PROJECT_APPROVALS_TIMESHEET': 'Project Approvals Timesheet',
  'PROJECT_ATTRIBUTES': 'Project Attributes',
  'PROJECT_CONFIGURATION': 'Project Configuration',
  'PROJECT_CONFIGURATION_BILLING_RATES': 'Project Configuration Billing Rates',
  'PROJECT_CONFIGURATION_COST_RATES': 'Project Configuration Cost Rates',
  'PROJECT_CONFIGURATION_GENERAL': 'Project Configuration General',
  'PROJECT_CONFIGURATION_MEMBERS_AND_ROLES': 'Project Configuration Members and Roles',
  'PROJECT_CONFIGURATION_PROJECT_ATTRIBUTES': 'Project Configuration Project Attributes',
  'PROJECT_CONFIGURATION_PROJECT_TIME_APPROVAL': 'Project Configuration Project Time Approval',
  'PROJECT_CONFIGURATION_SHARING': 'Project Configuration Sharing',
  'PROJECT_DEFAULTS': 'Project Defaults',
  'PROJECT_EXPENSES': 'Project Expenses',
  'PROJECT_FEATURES': 'Project Features',
  'PROJECT_LIST': 'Project List',
  'PROJECT_OVERVIEW': 'Project Overview',
  'PROJECT_REVENUE': 'Project Revenue',
  'PROJECT_SCOPE': 'Project Scope',
  'PROJECT_TEAM': 'Project Team',
  'PROJECT_TIME_APPROVAL': 'Project Time Approval',
  'PROJECT_TIMESHEET': 'Project Timesheet',
  'PROJECT_WELCOME': 'Project Welcome',
  'PROJECT_BOARD': 'Project board',
  'REPORT': 'Report',
  'REPORT_LIST': 'Report List',
  'REPORT_PAGE': 'Report Page',
  'REPORTS_DASHBOARD': 'Reports Dashboard',
  'REPORTS_OVERVIEW': 'Reports Overview',
  'RESET_PASSWORD': 'Reset Password',
  'RESOURCE_PLANNING': 'Resource Planning',
  'REVIEW_ALL_WORKLOGS': 'Review All Worklogs',
  'REVIEW_TIME': 'Review Time',
  'REVIEW_TIME_FINAL': 'Review Time Final',
  'ROADMAP_TABLE': 'Roadmap Table',
  'SSO_LOGIN': 'SSO Login',
  'SCHEDULED': 'Scheduled',
  'SCHEDULED_CHANGES': 'Scheduled - Changes',
  'SCHEDULED_DASHBOARD': 'Scheduled - Dashboard',
  'SCHEDULED_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Changes Widget Click-through',
  'SCHEDULED_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Dashboard Note Widget Click-through',
  'SCHEDULED_DASHBOARD_DESIGN': 'Scheduled - Dashboard - Design',
  'SCHEDULED_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Intake Widget Click-through',
  'SCHEDULED_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Scheduled - Dashboard - Intake Widget Settings',
  'SCHEDULED_DASHBOARD_LIST_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - List Widget Click-through',
  'SCHEDULED_DASHBOARD_METRIC_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Metric Widget Click-through',
  'SCHEDULED_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Task Board Widget Click-through',
  'SCHEDULED_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Scheduled - Dashboard - Workload Widget Click-through',
  'SCHEDULED_GRID': 'Scheduled - Grid',
  'SCHEDULED_REPORT': 'Scheduled - Report',
  'SCHEDULED_REPORT_DESIGN': 'Scheduled - Report - Design',
  'SCHEDULED_SEARCH': 'Scheduled - Search',
  'SCHEDULED_WORKLOAD': 'Scheduled - Workload',
  'SCHEDULER_CONFIGURATION': 'Scheduler Configuration',
  'SEARCH': 'Search',
  'SET_PASSWORD': 'Set Password',
  'SETTINGS': 'Settings',
  'SINGLE_SIGN_ON': 'Single Sign On',
  'SINGLE_SIGN_ON_MANAGE_SSO': 'Single Sign On - Manage SSO',
  'SINGLE_SIGN_ON_SETUP': 'Single Sign On - Setup',
  'SKILLS': 'Skills',
  'SLACK_INTEGRATION': 'Slack Integration',
  'STANDALONE_WORKLOG_DIALOG': 'Standalone Worklog Dialog',
  'STRUCTURE_EMPTY_STATE': 'Structure Empty State',
  'TASK_VIEW': 'Task View',
  'TEAM_APPROVALS': 'Team Approvals',
  'TEAM_CAPACITY': 'Team Capacity',
  'TEAM_CLASSIFICATION': 'Team Classification',
  'TEAM_MEMBER_CAPACITY_REPORT': 'Team Member Capacity Report',
  'TEAM_MEMBERSHIP': 'Team Membership',
  'TEAM_OVERVIEW': 'Team Overview',
  'TEAM_PERMISSIONS': 'Team Permissions',
  'TEAM_PLANNING': 'Team Planning',
  'TEAM_ROLES': 'Team Roles',
  'TEAM_TIMESHEET': 'Team Timesheet',
  'TEAMS_CLASSIFICATION': 'Teams Classification',
  'TEAMS_OVERVIEW': 'Teams Overview',
  'TEMPLATE': 'Template',
  'TEMPO_ACCOUNTS': 'Tempo Accounts',
  'TEMPO_APPS': 'Tempo Apps',
  'TEMPO_ERROR': 'Tempo Error',
  'TEMPO_MY_WORK': 'Tempo My Work',
  'TEMPO_PROJECT_CONFIG': 'Tempo Project Config',
  'TEMPO_REPORTS': 'Tempo Reports',
  'TEMPO_TEAMS': 'Tempo Teams',
  'TIME_TRACKING_MODE': 'Time Tracking Mode',
  'TIMESHEETS': 'Timesheets',
  'TRACKER': 'Tracker',
  'TRIAL_SIGN_UP': 'Trial Sign Up',
  'UI_PREFERENCES': 'UI Preferences',
  'UPGRADE': 'Upgrade',
  'USER_APPROVAL_LOG': 'User Approval Log',
  'USER_APPROVAL_TIMESHEET': 'User Approval Timesheet',
  'USER_TIMESHEET': 'User Timesheet',
  'WORK_ATTRIBUTES': 'Work Attributes',
  'WORKLOAD': 'Workload',
  'WORKLOAD_SCHEME_MEMBERS': 'Workload Scheme Members',
  'WORKLOAD_SCHEMES': 'Workload Schemes',
  'WORKLOG_CALENDAR': 'Worklog Calendar',
  'WORKLOG_EDITOR_BULK_ACTIONS': 'Worklog Editor Bulk Actions',
  'WORKLOG_SYNC': 'Worklog Sync',
  'WORKSPACE': 'Workspace',
  'WORKSPACE_LIBRARY': 'Workspace -  Library',
  'WORKSPACE_BILLING_RATE_SHEETS_PROJECTS_USING': 'Workspace - Billing Rate Sheets - Projects Using',
  'WORKSPACE_BILLING_RATE_SHEETS_RULES': 'Workspace - Billing Rate Sheets - Rules',
  'WORKSPACE_COST_CODES': 'Workspace - Cost Codes',
  'WORKSPACE_CUSTOM_DATA': 'Workspace - Custom Data',
  'WORKSPACE_CUSTOMIZE_STATUS': 'Workspace - Customize Status',
  'WORKSPACE_DASHBOARD': 'Workspace - Dashboard',
  'WORKSPACE_DASHBOARD_CHANGES_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Changes Widget Click-through',
  'WORKSPACE_DASHBOARD_DASHBOARD_NOTE_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Dashboard Note Widget Click-through',
  'WORKSPACE_DASHBOARD_DESIGN': 'Workspace - Dashboard - Design',
  'WORKSPACE_DASHBOARD_INTAKE_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Intake Widget Click-through',
  'WORKSPACE_DASHBOARD_INTAKE_WIDGET_SETTINGS': 'Workspace - Dashboard - Intake Widget Settings',
  'WORKSPACE_DASHBOARD_LIST_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - List Widget Click-through',
  'WORKSPACE_DASHBOARD_METRICS_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Metrics Widget Click-through',
  'WORKSPACE_DASHBOARD_TASK_BOARD_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Task Board Widget Click-through',
  'WORKSPACE_DASHBOARD_WORKLOAD_WIDGET_CLICK_THROUGH': 'Workspace - Dashboard - Workload Widget Click-through',
  'WORKSPACE_PAY_RATE_SHEETS_PROJECTS_USING': 'Workspace - Pay Rate Sheets - Projects Using',
  'WORKSPACE_PAY_RATE_SHEETS_RULES': 'Workspace - Pay Rate Sheets - Rules',
  'WORKSPACE_RATE_SHEET_TABLE': 'Workspace - Rate Sheet Table',
  'WORKSPACE_REPORT': 'Workspace - Report',
  'WORKSPACE_REPORT_DESIGN': 'Workspace - Report - Design',
  'WORKSPACE_SETTINGS': 'Workspace - Settings',
  'ITERATIONS': 'Iterations',
  'PROJECT_NOT_FOUND': 'Project Not Found',
  'REPORT_NOT_FOUND': 'Report Not Found',
  'CUSTOM_FIELDS': 'Custom Fields',
  'CUSTOMERS': 'Customers',
  'IDEAS': 'Ideas',
  'INBOX': 'Inbox',
  'OVERVIEW': 'Overview',
  'PORTALS': 'Portals',
  'PRODUCT_AREAS': 'Product Areas',
  'BASE_APP_ONBOARDING': 'Base app onboarding',
  'COPY_TO_JIRA_HISTORY': 'Copy to Jira History',
  'CREATE': 'Create',
  'WELCOME': 'Welcome',
  'INSIGHTS_DASHBOARD': 'Insights Dashboard',
  'ONBOARDING': 'Onboarding',
} as const;
export type OriginPageType = typeof OriginPage;
export type OriginPageValueType = OriginPageType[keyof OriginPageType];

export const RoleType = {
  'GLOBAL': 'Global',
  'RESTRICTED': 'Restricted',
  'MEMBER': 'Member',
  'ADMIN': 'Admin',
} as const;
export type RoleTypeType = typeof RoleType;
export type RoleTypeValueType = RoleTypeType[keyof RoleTypeType];

export const FiltersApplied = {
  'ACCOUNT': 'Account',
  'ACCOUNT_CATEGORY': 'Account Category',
  'ACCOUNT_STATUS': 'Account status',
  'ALL_DATA': 'All data',
  'ALL_PLANS': 'All plans',
  'ALL_WORKLOGS': 'All worklogs',
  'APPROVALS_STATUS': 'Approvals status',
  'AVAILABLE': 'Available',
  'CATEGORY': 'Category',
  'CATEGORY_TYPE': 'Category type',
  'CONTACT': 'Contact',
  'CUSTOMER': 'Customer',
  'EPIC_KEY': 'Epic key',
  'EXCLUDE_INTERNAL_ISSUES': 'Exclude internal issues',
  'EXPENSE_CATEGORY': 'Expense Category',
  'GENERIC_RESOURCE': 'Generic resource',
  'INCLUDE_REJECTED_RECORDS': 'Include rejected records',
  'INCLUDE_SUB_TASKS_IN_ISSUE': 'Include sub-tasks in issue',
  'ISSUE': 'Issue',
  'JIRA_FILTERS': 'Jira filters',
  'JQL': 'Jql',
  'LEAD': 'Lead',
  'MEMBER': 'Member',
  'MY_DATA': 'My data',
  'MY_PLAN': 'My plan',
  'MY_WORKLOGS': 'My worklogs',
  'PLANNED': 'Planned',
  'PROGRAM': 'Program',
  'PROJECT': 'Project',
  'ROLE': 'Role',
  'SEARCH': 'Search',
  'SKILL': 'Skill',
  'TASK_KEY': 'Task key',
  'TEAM': 'Team',
  'USER': 'User',
  'REVENUE_CATEGORY': 'Revenue Category',
  'PLAN': 'Plan',
  'STATUS': 'Status',
  'ITEM_TYPE': 'Item Type',
  'INTEGRATION': 'Integration',
  'EXPECTED_START_DATE': 'Expected Start Date',
  'EXPECTED_FINISH_DATE': 'Expected Finish Date',
  'LATEST_FINISH_DATE': 'Latest Finish Date',
} as const;
export type FiltersAppliedType = typeof FiltersApplied;
export type FiltersAppliedValueType = FiltersAppliedType[keyof FiltersAppliedType];

export const OriginAction = {
  'ACTIVATING_INNOVATION': 'Activating innovation',
  'ADD': 'Add',
  'ADD_TEAM_MEMBER': 'Add Team Member',
  'ADD_WORKLOG_HEADER_CLICKED': 'Add Worklog Header Clicked',
  'ADD_WORKLOG_MODAL_CLICKED': 'Add Worklog Modal Clicked',
  'ADD_CARD': 'Add card',
  'ADD_COLUMN': 'Add column',
  'ADD_ISSUE_DIALOG': 'Add issue dialog',
  'ADD_MARKER': 'Add marker',
  'ADDED': 'Added',
  'ADDED_ACCOUNT_PROJECT_LINK': 'Added Account Project Link',
  'ADDED_APPLICATION': 'Added Application',
  'ADDED_BUDGET_MILESTONE': 'Added Budget Milestone',
  'ADDED_CHART': 'Added Chart',
  'ADDED_COLUMN': 'Added Column',
  'ADDED_EFFECTIVE_DATE_RATE': 'Added Effective Date Rate',
  'ADDED_FIXED_DAY_TO_HOLIDAY_SCHEME': 'Added Fixed Day to Holiday Scheme',
  'ADDED_FLOATING_DAY_TO_HOLIDAY_SCHEME': 'Added Floating Day to Holiday Scheme',
  'ADDED_PERMISSION_ROLE': 'Added Permission Role',
  'ADDED_PROJECT': 'Added Project',
  'ADDED_PROJECT_ATTRIBUTE': 'Added Project Attribute',
  'ADDED_PROJECT_LINK_TO_TEAM': 'Added Project Link to Team',
  'ADDED_SCHEDULING': 'Added Scheduling',
  'ADDED_SKILL': 'Added Skill',
  'ADDED_STORY_POINT': 'Added Story Point',
  'ADDED_TASK': 'Added Task',
  'ADDED_TEAM_MEMBER': 'Added Team Member',
  'ADDED_TEAM_MEMBERS_IN_BULK': 'Added Team Members In Bulk',
  'ADDED_TEAM_ROLE': 'Added Team Role',
  'ADDED_TEAMS': 'Added Teams',
  'ADDED_WORK_ATTRIBUTE': 'Added Work Attribute',
  'ALL_TAGS_CLEARED': 'All Tags Cleared',
  'ALLOW_DUPLICATION_DISABLED': 'Allow Duplication Disabled',
  'ALLOW_DUPLICATION_ENABLED': 'Allow Duplication Enabled',
  'ALLOWED': 'Allowed',
  'ANYWHERE': 'Anywhere',
  'APP_MENU': 'App menu',
  'APPLIED_ACCOUNT_RATES': 'Applied Account Rates',
  'APPLIED_GLOBAL_COST_RATE': 'Applied Global Cost Rate',
  'APPLY_FOREST_ACTION': 'Apply forest action',
  'APPROVED': 'Approved',
  'APPROVERS_ADDED': 'Approvers Added',
  'APPROVERS_REMOVED': 'Approvers Removed',
  'ASSIGNED_TO_TEAM': 'Assigned to Team',
  'AUTO_CREATE_CONFIGURATION': 'Auto-create configuration',
  'AUTOMATIC_UPDATE': 'Automatic Update',
  'BACKLOG_CARD_ACTION': 'Backlog card action',
  'BACKLOG_CLOSED': 'Backlog closed',
  'BACKLOG_LOADMORE': 'Backlog loadmore',
  'BACKLOG_OPENED': 'Backlog opened',
  'BACKLOG_REFRESH': 'Backlog refresh',
  'BOARDS': 'Boards',
  'BULK_DELETE': 'Bulk Delete',
  'BULK_EDIT': 'Bulk Edit',
  'BULK_MOVE': 'Bulk Move',
  'CHANGE_REPORT_DISPLAY_TO_OVERVIEW': 'Change Report Display to Overview',
  'CHANGE_BAR': 'Change bar',
  'CHANGE_TO_AVAILABILITY': 'Change to Availability',
  'CHANGE_TO_CARDS': 'Change to Cards',
  'CHANGE_TO_HOURS': 'Change to Hours',
  'CHANGE_TO_TOTAL_HOURS': 'Change to Total Hours',
  'CHANGED_ACCESS_TYPE': 'Changed Access type',
  'CHANGED_BREAKDOWN_METHOD': 'Changed Breakdown Method',
  'CHANGED_ISSUE_IN_REPORTS': 'Changed Issue in Reports',
  'CHANGED_MAX_DAYS_USERS_CAN_LOG_FUTURE_WORK': 'Changed Max Days Users Can Log Future Work',
  'CHANGED_MAX_HOURS_USERS_CAN_LOG_WORK_PER_DAY': 'Changed Max Hours Users Can Log Work per Day',
  'CHANGED_PRINT_REPORT_TO_LANDSCAPE': 'Changed Print Report to Landscape',
  'CHANGED_PRINT_REPORT_TO_PORTRAIT': 'Changed Print Report to Portrait',
  'CHANGED_PROGRAM_MANAGER': 'Changed Program Manager',
  'CHANGED_PROGRAM_TEAM': 'Changed Program Team',
  'CHANGED_PROJECT_SCOPE': 'Changed Project Scope',
  'CHANGED_REPORT_DATE_DISPLAY_TO_DAYS': 'Changed Report Date Display to Days',
  'CHANGED_REPORT_DATE_DISPLAY_TO_MONTHS': 'Changed Report Date Display to Months',
  'CHANGED_REPORT_DATE_DISPLAY_TO_QUARTERS': 'Changed Report Date Display to Quarters',
  'CHANGED_REPORT_DATE_DISPLAY_TO_WEEKS': 'Changed Report Date Display to Weeks',
  'CHANGED_SORTING': 'Changed Sorting',
  'CHANGED_TEAM': 'Changed Team',
  'CHANGED_TIME_UNIT': 'Changed Time Unit',
  'CHANGED_TIMELINE_TIME_UNIT': 'Changed Timeline Time Unit',
  'CHANGED_DATE_FORMAT': 'Changed date format',
  'CHANGED_DURATION_FORMAT': 'Changed duration format',
  'CHANGED_THE_FIRST_DAY_OF_WEEK': 'Changed the first day of week',
  'CHANGED_TIME_FORMAT': 'Changed time format',
  'CLEAR_DELAYS_AND_RUN_LEVELING': 'Clear Delays and Run Leveling',
  'CLICK_PROVIDE_FEEDBACK': 'Click Provide Feedback',
  'CLICK_COPY_LINK': 'Click copy link',
  'CLICK_SHARE_BUTTON': 'Click share button',
  'CLICK_SHARE_TOGGLE': 'Click share toggle',
  'CLICKED': 'Clicked',
  'CLICKED_ADD_ITEM_BUTTON': 'Clicked Add Item Button',
  'CLICKED_ALLOW': 'Clicked Allow',
  'CLICKED_APPLY_ON_PERIOD_NAVIGATION': 'Clicked Apply on Period Navigation',
  'CLICKED_APPROVAL_LOG': 'Clicked Approval Log',
  'CLICKED_APPROVE_BUTTON': 'Clicked Approve Button',
  'CLICKED_BILLING_RATES': 'Clicked Billing Rates',
  'CLICKED_BULK_TIME_RECORDS_EDITOR': 'Clicked Bulk Time Records Editor',
  'CLICKED_CANCEL': 'Clicked Cancel',
  'CLICKED_CARD_ON_CANVAS': 'Clicked Card on Canvas',
  'CLICKED_CONNECT': 'Clicked Connect',
  'CLICKED_CONTACT_SALES': 'Clicked Contact Sales',
  'CLICKED_CONTACT_US': 'Clicked Contact Us',
  'CLICKED_COST_RATES': 'Clicked Cost Rates',
  'CLICKED_DELETE_BUTTON': 'Clicked Delete Button',
  'CLICKED_DONT_ALLOW': 'Clicked Don\'t Allow',
  'CLICKED_HELP_CENTER': 'Clicked Help Center',
  'CLICKED_HORIZONTAL_COLLAPSE': 'Clicked Horizontal Collapse',
  'CLICKED_HORIZONTAL_EXPAND': 'Clicked Horizontal Expand',
  'CLICKED_HOURS': 'Clicked Hours',
  'CLICKED_LEARN_MORE': 'Clicked Learn More',
  'CLICKED_LOG_WORK_BUTTON': 'Clicked Log Work Button',
  'CLICKED_MY_WORK_IN_NAVIGATION_MENU': 'Clicked My Work in Navigation Menu',
  'CLICKED_NEW_IMPORTANT_INFO': 'Clicked New & Important Info',
  'CLICKED_OPEN_STRUCTURE': 'Clicked Open Structure',
  'CLICKED_PAUSE_BUTTON': 'Clicked Pause Button',
  'CLICKED_PLAN_TIME_BUTTON': 'Clicked Plan Time Button',
  'CLICKED_PLUS_BUTTON': 'Clicked Plus Button',
  'CLICKED_PROJECT_APPROVAL_TAB': 'Clicked Project Approval Tab',
  'CLICKED_PROJECT_TIME_APPROVALS': 'Clicked Project Time Approvals',
  'CLICKED_REJECT_BUTTON': 'Clicked Reject Button',
  'CLICKED_REOPEN_BUTTON': 'Clicked Reopen Button',
  'CLICKED_REPORTS_IN_NAVIGATION_MENU': 'Clicked Reports in Navigation Menu',
  'CLICKED_RESUME_BUTTON': 'Clicked Resume Button',
  'CLICKED_RETURN_TO_START_BUTTON': 'Clicked Return To Start Button',
  'CLICKED_REVIEW_TIME': 'Clicked Review Time',
  'CLICKED_SHOW_MORE': 'Clicked Show More',
  'CLICKED_SHOW_MY_WORK': 'Clicked Show My Work',
  'CLICKED_TECHNICAL_SUPPORT': 'Clicked Technical Support',
  'CLICKED_TEMPO_SETTINGS': 'Clicked Tempo Settings',
  'CLICKED_TEMPO_STATUS': 'Clicked Tempo Status',
  'CLICKED_UPGRADE': 'Clicked Upgrade',
  'CLICKED_VERTICAL_COLLAPSE': 'Clicked Vertical Collapse',
  'CLICKED_VERTICAL_EXPAND': 'Clicked Vertical Expand',
  'CLICKED_X_ON_FORM': 'Clicked X on Form',
  'CLICKED_IN_CELL': 'Clicked in Cell',
  'CLICKED_IN_TASK_PANEL': 'Clicked in Task Panel',
  'CLICKED_ON_ACADEMY': 'Clicked on Academy',
  'CLICKED_ON_ACCOUNT': 'Clicked on Account',
  'CLICKED_ON_ADD_EFFECTIVE_DATE_RATE': 'Clicked on Add Effective Date Rate',
  'CLICKED_ON_ADD_PROJECT': 'Clicked on Add Project',
  'CLICKED_ON_ADD_TEAMS_BUTTON': 'Clicked on Add Teams Button',
  'CLICKED_ON_ADMINISTRATION': 'Clicked on Administration',
  'CLICKED_ON_ARROW': 'Clicked on Arrow',
  'CLICKED_ON_BACK_ARROW': 'Clicked on Back Arrow',
  'CLICKED_ON_CANCEL_BUTTON': 'Clicked on Cancel Button',
  'CLICKED_ON_CANVAS': 'Clicked on Canvas',
  'CLICKED_ON_CANVAS_HEADER_BUTTON': 'Clicked on Canvas Header Button',
  'CLICKED_ON_CAPEX_LINK': 'Clicked on Capex Link',
  'CLICKED_ON_CELL': 'Clicked on Cell',
  'CLICKED_ON_CLOSE': 'Clicked on Close',
  'CLICKED_ON_CLOSE_BUTTON': 'Clicked on Close Button',
  'CLICKED_ON_CONFIRM': 'Clicked on Confirm',
  'CLICKED_ON_CREATE_BUTTON': 'Clicked on Create Button',
  'CLICKED_ON_CURRENT_LINK': 'Clicked on Current Link',
  'CLICKED_ON_DASHBOARD_PASSPORT': 'Clicked on Dashboard Passport',
  'CLICKED_ON_DATE': 'Clicked on Date',
  'CLICKED_ON_DAYS_BUTTON': 'Clicked on Days Button',
  'CLICKED_ON_DELETE_PORTFOLIO': 'Clicked on Delete Portfolio',
  'CLICKED_ON_DONT_SHOW_THIS_AGAIN': 'Clicked on Don\'t Show This Again',
  'CLICKED_ON_DROPDOWN': 'Clicked on Dropdown',
  'CLICKED_ON_EXPANDED_CELL': 'Clicked on Expanded Cell',
  'CLICKED_ON_EXPORT_BUTTON': 'Clicked on Export Button',
  'CLICKED_ON_FAVORITE': 'Clicked on Favorite',
  'CLICKED_ON_FILTER_PICKER': 'Clicked on Filter Picker',
  'CLICKED_ON_FORWARD_ARROW': 'Clicked on Forward Arrow',
  'CLICKED_ON_FULL_DESCRIPTION_LINK': 'Clicked on Full Description Link',
  'CLICKED_ON_GAP_SUGGESTION': 'Clicked on Gap Suggestion',
  'CLICKED_ON_GRACE_GRANTED_ITEM': 'Clicked on Grace Granted Item',
  'CLICKED_ON_GROUPING_FILTER': 'Clicked on Grouping Filter',
  'CLICKED_ON_HELP': 'Clicked on Help',
  'CLICKED_ON_INCLUDE_COMPLETED_PROJECT': 'Clicked on Include Completed Project',
  'CLICKED_ON_ISSUE_ACTIONS': 'Clicked on Issue Actions',
  'CLICKED_ON_ITERATIONS_LINK': 'Clicked on Iterations Link',
  'CLICKED_ON_LAST_LINK': 'Clicked on Last Link',
  'CLICKED_ON_LIBRARY': 'Clicked on Library',
  'CLICKED_ON_LOG_TIME_BUTTON': 'Clicked on Log Time button',
  'CLICKED_ON_LOG_WORK_LINK_FROM_DROPDOWN': 'Clicked on Log Work Link from Dropdown',
  'CLICKED_ON_MOVE_LINK': 'Clicked on Move Link',
  'CLICKED_ON_MY_DISCUSSIONS': 'Clicked on My Discussions',
  'CLICKED_ON_MY_FAVORITES': 'Clicked on My Favorites',
  'CLICKED_ON_MY_WORK': 'Clicked on My Work',
  'CLICKED_ON_NOTIFICATION_LINK': 'Clicked on Notification Link',
  'CLICKED_ON_OPEX_LINK': 'Clicked on Opex Link',
  'CLICKED_ON_PEOPLE': 'Clicked on People',
  'CLICKED_ON_PLAN': 'Clicked on Plan',
  'CLICKED_ON_PORTFOLIO_LINK_PROJECT': 'Clicked on Portfolio Link - Project',
  'CLICKED_ON_PORTFOLIO_TILE': 'Clicked on Portfolio Tile',
  'CLICKED_ON_PREMIUM_FEATURES_TRIAL': 'Clicked on Premium Features Trial',
  'CLICKED_ON_PRINT_BUTTON_IN_LANDSCAPE_MODE': 'Clicked on Print Button in Landscape mode',
  'CLICKED_ON_PRINT_BUTTON_IN_PORTRAIT_MODE': 'Clicked on Print Button in Portrait mode',
  'CLICKED_ON_PROJECT_STATUS': 'Clicked on Project Status',
  'CLICKED_ON_PROJECTS': 'Clicked on Projects',
  'CLICKED_ON_QUICK_ACTION': 'Clicked on Quick Action',
  'CLICKED_ON_RE_IMPORT_SCOPE': 'Clicked on Re-Import Scope',
  'CLICKED_ON_REMOVE_PROJECT': 'Clicked on Remove Project',
  'CLICKED_ON_REMOVE_TEAMS_BUTTON': 'Clicked on Remove Teams Button',
  'CLICKED_ON_REVIEW_ALL': 'Clicked on Review All',
  'CLICKED_ON_SHARE_BUTTON': 'Clicked on Share Button',
  'CLICKED_ON_SKIP': 'Clicked on Skip',
  'CLICKED_ON_SUBMIT_BUTTON': 'Clicked on Submit Button',
  'CLICKED_ON_SUBSCRIBE': 'Clicked on Subscribe',
  'CLICKED_ON_TEAM_MEMBER_LINK': 'Clicked on Team Member Link',
  'CLICKED_ON_TIME_AXIS': 'Clicked on Time Axis',
  'CLICKED_ON_TIMERECORD': 'Clicked on TimeRecord',
  'CLICKED_ON_TIMESHEET': 'Clicked on TimeSheet',
  'CLICKED_ON_TIMESHEET_DUE': 'Clicked on Timesheet Due',
  'CLICKED_ON_TODAY_BUTTON': 'Clicked on Today Button',
  'CLICKED_ON_TODAY_LINK': 'Clicked on Today Link',
  'CLICKED_ON_ULTIMATE_TRIAL': 'Clicked on Ultimate Trial',
  'CLICKED_ON_VIEW_REPORT': 'Clicked on View Report',
  'CLICKED_ON_WEEK_HEADER': 'Clicked on Week Header',
  'CLICKED_ON_WEEKS_BUTTON': 'Clicked on Weeks Button',
  'CLICKED_ON_WORKSPACE_LINK': 'Clicked on Workspace Link',
  'CLICKED_ON_EFFORT_TYPES_TO_FILTER_DATA': 'Clicked on effort types to filter data',
  'CLICKED_ON_TITLE_TO_VIEW_REPORT': 'Clicked on title to view report',
  'CLOSED_PERIOD_FOR_ALL': 'Closed Period for All',
  'COLLAPSE_ALL': 'Collapse all',
  'COLLAPSE_NEXT_LEVEL': 'Collapse next level',
  'COLLAPSED': 'Collapsed',
  'COLLAPSED_CHART': 'Collapsed Chart',
  'COLUMN_VALUE_RESOLUTION_TASK': 'Column value resolution task',
  'COMMAND_LINE': 'Command Line',
  'COMPRESS_ROWS': 'Compress Rows',
  'COMPRESSED_CARDS': 'Compressed Cards',
  'CONFIGURE': 'Configure',
  'CONNECT': 'Connect',
  'CONVERTED_GOOGLE_CAL_EVENT': 'Converted Google Cal Event',
  'CONVERTED_OFFICE_365_CAL_EVENT': 'Converted Office 365 Cal Event',
  'CONVERTED_PLAN': 'Converted Plan',
  'CONVERTED_SUGGESTION': 'Converted Suggestion',
  'CONVERTED_TRACKER': 'Converted Tracker',
  'CONVERTED_FROM_SUGGESTION': 'Converted from Suggestion',
  'COPIED_PLAN': 'Copied Plan',
  'COPIED_TIME_RECORD': 'Copied Time Record',
  'COPIED_WORKLOG': 'Copied Worklog',
  'COPY': 'Copy',
  'CREATE_NEW_CHART': 'Create New Chart',
  'CREATE_NEW_ISSUE_LIST': 'Create New Issue List',
  'CREATE_NEW_SIMPLE_SEARCH': 'Create New Simple Search',
  'CREATE_BASELINE': 'Create baseline',
  'CREATE_CONFIGURATION': 'Create configuration',
  'CREATE_DEPENDENCY': 'Create dependency',
  'CREATE_FOLDER_DIALOG': 'Create folder dialog',
  'CREATE_LINK': 'Create link',
  'CREATE_MILESTONE': 'Create milestone',
  'CREATE_STATUS': 'Create status',
  'CREATE_STRUCTURE': 'Create structure',
  'CREATED_CATEGORY': 'Created Category',
  'CREATED_CUSTOMER': 'Created Customer',
  'CREATED_EXPENSE': 'Created Expense',
  'CREATED_NEW_TOKEN': 'Created New Token',
  'CREATED_NEW_TRACKER': 'Created New Tracker',
  'CREATED_PROJECT_GROUP': 'Created Project Group',
  'CREATED_ROLE': 'Created Role',
  'CREATED_SKILL': 'Created Skill',
  'CREATED_TAG': 'Created Tag',
  'CREATED_FROM_TRACKER': 'Created from Tracker',
  'CUT': 'Cut',
  'DASHBOARD_ITEM': 'Dashboard item',
  'DEACTIVATING_INNOVATION': 'Deactivating innovation',
  'DELETE': 'Delete',
  'DELETE_ENTIRE_PLAN': 'Delete Entire Plan',
  'DELETE_ENTIRE_RECURRING_PLAN_SERIES': 'Delete Entire Recurring Plan Series',
  'DELETE_PARTIAL_PLAN': 'Delete Partial Plan',
  'DELETE_BY_SWIPING': 'Delete by Swiping',
  'DELETE_LINK': 'Delete link',
  'DELETE_STATUS': 'Delete status',
  'DELETE_SUBTREE': 'Delete subtree',
  'DELETE_THIS_AND_UPCOMING_FROM_REPEATED_PLAN_SERIES': 'Delete this and upcoming from repeated plan series',
  'DELETED': 'Deleted',
  'DELETED_CATEGORY': 'Deleted Category',
  'DELETED_CUSTOMER': 'Deleted Customer',
  'DELETED_EFFECTIVE_DATE_RATE': 'Deleted Effective Date Rate',
  'DELETED_EXPENSE': 'Deleted Expense',
  'DELETED_PERMISSION_ROLE': 'Deleted Permission Role',
  'DELETED_ROLE': 'Deleted Role',
  'DELETED_SKILL': 'Deleted Skill',
  'DELETED_TAG': 'Deleted Tag',
  'DELETED_TEAM_MEMBER': 'Deleted Team Member',
  'DELETED_TOKEN': 'Deleted Token',
  'DELETED_WORK_ATTRIBUTE': 'Deleted Work Attribute',
  'DEPICTION_CHANGE': 'Depiction Change',
  'DETAILS_EDITED': 'Details Edited',
  'DISABLE': 'Disable',
  'DISABLE_TRANSFORMATION': 'Disable Transformation',
  'DISABLED_ACCOUNT_GLOBAL': 'Disabled Account Global',
  'DISABLED_ACCOUNT_RATES': 'Disabled Account Rates',
  'DISABLED_DELETE_PLANS_WHEN_ASSOCIATED_ISSUES_ARE_DELETED': 'Disabled Delete plans when associated issues are deleted',
  'DISABLED_GLOBAL_COST_RATE': 'Disabled Global Cost Rate',
  'DISABLED_LOGGING_ON_CLOSED_AND_ARCHIVED_ACCOUNTS': 'Disabled Logging on Closed and Archived Accounts',
  'DISABLED_PLAN_APPROVAL': 'Disabled Plan Approval',
  'DISABLED_PROJECT_TIME_APPROVAL': 'Disabled Project Time Approval',
  'DISABLED_REVENUE_TRACKING': 'Disabled Revenue Tracking',
  'DISABLED_SHOW_USERS_WITH_ZERO_HOURS': 'Disabled Show Users With Zero Hours',
  'DISABLED_SYNC_PLANS_WITH_JIRA_ISSUES': 'Disabled Sync Plans With Jira Issues',
  'DISABLED_OVERRIDE_CLOSED_PERIODS_AND_APPROVED_TIMESHEETS': 'Disabled override closed periods and approved timesheets',
  'DISCONNECT': 'Disconnect',
  'DRAGGED_PLAN_AROUND_CANVAS': 'Dragged Plan around Canvas',
  'DRAGGED_SUGGESTION_ON_CANVAS': 'Dragged Suggestion on Canvas',
  'DRAGGED_SUGGESTION_TO_CANVAS': 'Dragged Suggestion to Canvas',
  'DRAGGED_WORKLOG': 'Dragged Worklog',
  'DRAGGED_WORKLOG_AROUND_CANVAS': 'Dragged Worklog around Canvas',
  'DRAGGED_ISSUE_TO_AVAILABLE_DATE_IN_WEEKS_VIEW': 'Dragged issue to available date in weeks view',
  'DUPLICATED': 'Duplicated',
  'DUPLICATED_ITEM_FROM_TABLE_VALUE': 'Duplicated Item from Table Value',
  'EDIT': 'Edit',
  'EDIT_SUGGESTION': 'Edit Suggestion',
  'EDITED_ACCOUNT_CATEGORY': 'Edited Account Category',
  'EDITED_ACCOUNT_CONTACT': 'Edited Account Contact',
  'EDITED_ACCOUNT_CUSTOMER': 'Edited Account Customer',
  'EDITED_ACCOUNT_LEAD': 'Edited Account Lead',
  'EDITED_ACCOUNT_MONTHLY_BUDGET': 'Edited Account Monthly Budget',
  'EDITED_ACCOUNT_NAME': 'Edited Account Name',
  'EDITED_ACCOUNT_STATUS': 'Edited Account Status',
  'EDITED_APPLICATION': 'Edited Application',
  'EDITED_CATEGORY': 'Edited Category',
  'EDITED_COLOR_TAG': 'Edited Color-Tag',
  'EDITED_CUSTOMER': 'Edited Customer',
  'EDITED_DATE': 'Edited Date',
  'EDITED_DATE_FOR_A_HOLIDAY_SCHEME_CONFIGURATION': 'Edited Date for a Holiday Scheme Configuration',
  'EDITED_DESCRIPTION': 'Edited Description',
  'EDITED_DESCRIPTION_FOR_A_HOLIDAY_SCHEME_CONFIGURATION': 'Edited Description for a Holiday Scheme Configuration',
  'EDITED_DURATION': 'Edited Duration',
  'EDITED_DURATION_FOR_A_HOLIDAY_SCHEME_CONFIGURATION': 'Edited Duration for a Holiday Scheme Configuration',
  'EDITED_NAME': 'Edited Name',
  'EDITED_NAME_FOR_A_HOLIDAY_SCHEME_CONFIGURATION': 'Edited Name for a Holiday Scheme Configuration',
  'EDITED_PERMISSION_ROLE': 'Edited Permission Role',
  'EDITED_PLAN_IN_FORM': 'Edited Plan in Form',
  'EDITED_PORTFOLIO_COLOR_TAG': 'Edited Portfolio Color Tag',
  'EDITED_PORTFOLIO_DESCRIPTION': 'Edited Portfolio Description',
  'EDITED_PORTFOLIO_NAME': 'Edited Portfolio Name',
  'EDITED_ROLE': 'Edited Role',
  'EDITED_ROLE_SET_DEFAULT': 'Edited Role Set Default',
  'EDITED_SKILL': 'Edited Skill',
  'EDITED_TEAM_LEAD': 'Edited Team Lead',
  'EDITED_TEAM_MEMBER': 'Edited Team Member',
  'EDITED_TEAM_NAME': 'Edited Team Name',
  'EDITED_TEAM_PROGRAM': 'Edited Team Program',
  'EDITED_TEAM_ROLE': 'Edited Team Role',
  'EDITED_TEAM_SUMMARY': 'Edited Team Summary',
  'EDITED_TEAM_TYPE': 'Edited Team Type',
  'EDITED_TOKEN': 'Edited Token',
  'EDITED_WORK_ATTRIBUTE': 'Edited Work Attribute',
  'EDITED_WORKLOAD_SCHEME': 'Edited Workload Scheme',
  'EDITED_WORKLOAD_SCHEME_ADDED_MEMBER': 'Edited Workload Scheme Added Member',
  'EDITED_WORKLOAD_SCHEME_DESCRIPTION': 'Edited Workload Scheme Description',
  'EDITED_WORKLOAD_SCHEME_HOURS': 'Edited Workload Scheme Hours',
  'EDITED_WORKLOAD_SCHEME_MOVED_MEMBER': 'Edited Workload Scheme Moved Member',
  'EDITED_WORKLOAD_SCHEME_NAME': 'Edited Workload Scheme Name',
  'EDITED_WORKLOAD_SCHEME_SET_DEFAULT': 'Edited Workload Scheme Set Default',
  'EDITED_FOLDER_DIALOG': 'Edited folder dialog',
  'EDITED_SYNC_PLANS_WITH_JIRA_ISSUES': 'Edited sync plans with Jira issues',
  'EDITED_SYNC_TEAM_PLANS_WITH_JIRA_ISSUES': 'Edited sync team plans with Jira issues',
  'ENABLE': 'Enable',
  'ENABLE_TRANSFORMATION': 'Enable Transformation',
  'ENABLED_ACCOUNT_GLOBAL': 'Enabled Account Global',
  'ENABLED_DELETE_PLANS_WHEN_ASSOCIATED_ISSUES_ARE_DELETED': 'Enabled Delete plans when associated issues are deleted',
  'ENABLED_LOGGING_ON_CLOSED_AND_ARCHIVED_ACCOUNTS': 'Enabled Logging on Closed and Archived Accounts',
  'ENABLED_PLAN_APPROVAL': 'Enabled Plan Approval',
  'ENABLED_PROJECT_TIME_APPROVAL': 'Enabled Project Time Approval',
  'ENABLED_REVENUE_TRACKING': 'Enabled Revenue Tracking',
  'ENABLED_SHOW_USERS_WITH_ZERO_HOURS': 'Enabled Show Users With Zero Hours',
  'ENABLED_SYNC_PLANS_WITH_JIRA_ISSUES': 'Enabled Sync Plans With Jira Issues',
  'ENABLED_OVERRIDE_CLOSED_PERIODS_AND_APPROVED_TIMESHEETS': 'Enabled override closed periods and approved timesheets',
  'EXCLUDED_COMPLETED_PROJECTS': 'Excluded Completed Projects',
  'EXPAND_ROWS': 'Expand Rows',
  'EXPAND_SUGGESTION': 'Expand Suggestion',
  'EXPAND_ALL': 'Expand all',
  'EXPAND_LEVEL': 'Expand level',
  'EXPAND_NEXT_LEVEL': 'Expand next level',
  'EXPANDED': 'Expanded',
  'EXPANDED_CARD_ON_CANVAS': 'Expanded Card on Canvas',
  'EXPANDED_CARDS': 'Expanded Cards',
  'EXPANDED_CHART': 'Expanded Chart',
  'EXPORTED_ACCOUNTS': 'Exported Accounts',
  'EXPORTED_DETAILED_ACTUALS_DATA': 'Exported Detailed Actuals Data',
  'EXPORTED_DETAILED_PLANNED_DATA': 'Exported Detailed Planned Data',
  'EXPORTED_EXPENSES_ACTUALS_DATA': 'Exported Expenses Actuals Data',
  'EXPORTED_LABOR_DATA': 'Exported Labor Data',
  'EXPORTED_PORTFOLIO_SUMMARY': 'Exported Portfolio Summary',
  'EXPORTED_TASK_ACTUALS_DATA': 'Exported Task Actuals Data',
  'FACTOR_SET_AS_DIVISOR': 'Factor set as divisor',
  'FACTOR_WEIGHT_CHANGED': 'Factor weight changed',
  'FAVORITED': 'Favorited',
  'FILTER_SELECTED': 'Filter Selected',
  'FILTER_STRUCTURE_SEARCH_BAR': 'Filter structure search bar',
  'FILTERS_CLEARED': 'Filters Cleared',
  'GENERATOR': 'Generator',
  'GLOBAL_BILLING_RATE_CHANGED': 'Global Billing Rate Changed',
  'GLOBAL_COST_RATE_CHANGED': 'Global Cost Rate Changed',
  'GO_TO_INTERNAL_ISSUES': 'Go to internal Issues',
  'GROUP_BY_TIME': 'Group by Time',
  'GROUPED_TASKS_BY_EPICS': 'Grouped Tasks by Epics',
  'HIDE_ACTIVITY_PROVIDER': 'Hide Activity Provider',
  'HIDE_CALENDAR_EVENTS': 'Hide Calendar Events',
  'HIDE_CAPACITY_INDICATORS': 'Hide Capacity Indicators',
  'HIDE_GENERIC_PLANS': 'Hide Generic Plans',
  'HIDE_INCOMPLETE_ACTIVITY': 'Hide Incomplete Activity',
  'HIDE_ISSUES_SIDE_PANEL': 'Hide Issues Side Panel',
  'HIDE_KPI_PANEL': 'Hide KPI Panel',
  'HIDE_LARGE_CARDS': 'Hide Large Cards',
  'HIDE_PLANS': 'Hide Plans',
  'HIDE_REJECTED_ACTIVITY': 'Hide Rejected Activity',
  'HIDE_REJECTED_PLANS': 'Hide Rejected Plans',
  'HIDE_SKILLS': 'Hide Skills',
  'HIDE_WEEKENDS': 'Hide Weekends',
  'HIDE_SEARCH_BAR_PANEL': 'Hide search bar panel',
  'HIDE_TRANSFORMATION_PANEL': 'Hide transformation panel',
  'HORIZONTAL_SCROLL_DISABLED': 'Horizontal scroll disabled',
  'HORIZONTAL_SCROLL_ENABLED': 'Horizontal scroll enabled',
  'HOVER_ON_ACCOUNT_SETUP': 'Hover on Account Setup',
  'HOVERED_ON_UNCATEGORIZED': 'Hovered on Uncategorized',
  'IMPORT_MACRO': 'Import Macro',
  'IMPORT_CONFIGURATION': 'Import configuration',
  'IMPORT_FROM_JIRA': 'Import from Jira',
  'IMPORTED_ACCOUNTS': 'Imported Accounts',
  'IMPORTED_PROJECT_SCOPE': 'Imported Project Scope',
  'IN_PROGRESS_ISSUES': 'In Progress Issues',
  'INCLUDED_COMPLETED_PROJECTS': 'Included Completed Projects',
  'INLINE_EDITING': 'Inline Editing',
  'INLINE_CREATION': 'Inline creation',
  'INLINE_EDITING': 'Inline editing',
  'INPUT_VALUE_INTO_ITEM_TABLE': 'Input Value Into Item Table',
  'INTERACTIVE_FORM': 'Interactive Form',
  'ITEM_DETAILS_EDITED': 'Item Details Edited',
  'ITEM_DUPLICATED': 'Item Duplicated',
  'ITEM_MOVED': 'Item Moved',
  'ITEM_REPOSITIONED': 'Item Repositioned',
  'LEVEL_DOWN': 'Level down',
  'LEVEL_UP': 'Level up',
  'LOCK_COLOR_PALETTE_DISABLED': 'Lock Color Palette Disabled',
  'LOCK_COLOR_PALETTE_ENABLED': 'Lock Color Palette Enabled',
  'LOG_ALL_ACTIVITIES': 'Log All Activities',
  'LOG_ALL_DAILY_ACTIVITIES': 'Log All Daily Activities',
  'LOG_ALL_SUGGESTIONS': 'Log All Suggestions',
  'LOG_SUGGESTION': 'Log Suggestion',
  'MADE_REMAINING_ESTIMATE_OPTIONAL': 'Made Remaining Estimate Optional',
  'MADE_REMAINING_ESTIMATE_REQUIRED': 'Made Remaining Estimate Required',
  'MADE_START_AND_END_TIMES_DISABLED': 'Made Start And End Times Disabled',
  'MADE_START_AND_END_TIMES_ENABLED': 'Made Start And End Times Enabled',
  'MADE_START_AND_END_TIMES_FOR_PLANNING_DISABLED': 'Made Start And End Times For Planning Disabled',
  'MADE_START_AND_END_TIMES_FOR_PLANNING_ENABLED': 'Made Start And End Times For Planning Enabled',
  'MADE_TEAM_ADMINISTRATIVE': 'Made Team Administrative',
  'MADE_TEAM_SELF_MANAGED': 'Made Team Self Managed',
  'MADE_WORKLOG_DESCRIPTION_OPTIONAL': 'Made Worklog Description Optional',
  'MADE_WORKLOG_DESCRIPTION_REQUIRED': 'Made Worklog Description Required',
  'MANUAL_UPDATE': 'Manual update',
  'MEMBERS_ADDED': 'Members Added',
  'MEMBERS_REMOVED': 'Members Removed',
  'MODIFIED_BUDGET_MILESTONE': 'Modified Budget Milestone',
  'MODIFIED_DEFAULT_BILLING_RATE': 'Modified Default Billing Rate',
  'MODIFIED_DEFAULT_COST_RATE': 'Modified Default Cost Rate',
  'MODIFIED_EXPENSE': 'Modified Expense',
  'MODIFIED_INDIVIDUAL_BILLING_RATE': 'Modified Individual Billing Rate',
  'MODIFIED_INDIVIDUAL_COST_RATE': 'Modified Individual Cost Rate',
  'MODIFIED_PROJECT_ATTRIBUTE_VALUE': 'Modified Project Attribute Value',
  'MODIFIED_PROJECT_BUDGET': 'Modified Project Budget',
  'MODIFIED_PROJECT_CURRENCY': 'Modified Project Currency',
  'MODIFIED_PROJECT_NAME': 'Modified Project Name',
  'MODIFIED_PROJECT_STATUS': 'Modified Project Status',
  'MODIFIED_PROJECT_TIMEFRAME': 'Modified Project Timeframe',
  'MODIFIED_PROJECT_TYPE': 'Modified Project Type',
  'MODIFIED_SCOPE_ORDER': 'Modified Scope Order',
  'MODIFIED_TEAM_MEMBER_ROLE': 'Modified Team Member Role',
  'MODIFY_NAME': 'Modify Name',
  'MODIFY_PLAN': 'Modify Plan',
  'MOVE': 'Move',
  'MOVE_TEAM_MEMBER': 'Move Team Member',
  'MOVE_CARD': 'Move card',
  'MOVE_COLUMN': 'Move column',
  'MOVE_DOWN': 'Move down',
  'MOVE_UP': 'Move up',
  'MOVED_CARD_ON_CANVAS': 'Moved Card on Canvas',
  'MOVED_TASKS_TO_A_GROUP': 'Moved Tasks to a Group',
  'MULTIPLE_ATTRIBUTES_CHANGED': 'Multiple Attributes Changed',
  'NEW_ITEM': 'New Item',
  'NEW_ITEM_BELOW': 'New Item Below',
  'NEW_PLAN': 'New Plan',
  'NEW_SUB_ITEM': 'New Sub Item',
  'NEW_SUB_ITEM_BELOW': 'New Sub Item Below',
  'NOT_ALLOWED': 'Not Allowed',
  'ON_ARROW_DOWN': 'On Arrow Down',
  'ON_ARROW_UP': 'On Arrow Up',
  'ON_BLUR': 'On Blur',
  'ON_ENTER': 'On ENTER',
  'ON_ESCAPE': 'On ESCAPE',
  'ONBOARDING_MESSAGE': 'Onboarding Message',
  'OPENED_PERIOD_FOR_ALL': 'Opened Period for All',
  'OPENED_PERIOD_FOR_TIMESHEET_APPROVERS': 'Opened Period for Timesheet Approvers',
  'OPENED_PUSH_NOTIFICATION': 'Opened Push Notification',
  'PASTE': 'Paste',
  'PERIOD_CELL_SELECT': 'Period Cell Select',
  'PIN': 'Pin',
  'PIN_COLUMN': 'Pin column',
  'PINNED': 'Pinned',
  'PINNED_PORTFOLIO': 'Pinned Portfolio',
  'PINNED_REPORT': 'Pinned Report',
  'PRESSED_KEYBOARD_SHORTCUT': 'Pressed Keyboard Shortcut',
  'PROJECT_OVERVIEW': 'Project overview',
  'PROJECTS': 'Projects',
  'PULLED_FROM_JIRA': 'Pulled from Jira',
  'REASSIGN_PLANS': 'Reassign Plans',
  'REFRESH_PANELS': 'Refresh panels',
  'REGENERATED_TOKEN': 'Regenerated Token',
  'REJECTED': 'Rejected',
  'REMOVE': 'Remove',
  'REMOVE_BASELINE': 'Remove baseline',
  'REMOVE_COLUMN': 'Remove column',
  'REMOVE_DEPENDENCY': 'Remove dependency',
  'REMOVE_MARKER': 'Remove marker',
  'REMOVE_MILESTONE': 'Remove milestone',
  'REMOVED': 'Removed',
  'REMOVED_ACCOUNT_PROJECT_LINK': 'Removed Account Project Link',
  'REMOVED_BUDGET_MILESTONE': 'Removed Budget Milestone',
  'REMOVED_CHART': 'Removed Chart',
  'REMOVED_COLUMN': 'Removed Column',
  'REMOVED_FIXED_DAY_FROM_HOLIDAY_SCHEME': 'Removed Fixed Day from Holiday Scheme',
  'REMOVED_FLOATING_DAY_FROM_HOLIDAY_SCHEME': 'Removed Floating Day from Holiday Scheme',
  'REMOVED_GROUPING': 'Removed Grouping',
  'REMOVED_PROJECT': 'Removed Project',
  'REMOVED_PROJECT_ATTRIBUTE': 'Removed Project Attribute',
  'REMOVED_PROJECT_LINK_FROM_TEAM': 'Removed Project Link from Team',
  'REMOVED_SKILL': 'Removed Skill',
  'REMOVED_STORY_POINT': 'Removed Story Point',
  'REMOVED_TASK': 'Removed Task',
  'REMOVED_TEAM_ROLE': 'Removed Team Role',
  'REMOVED_TEAMS': 'Removed Teams',
  'RENAMED_PROGRAM': 'Renamed Program',
  'RENAMED_REPORT': 'Renamed Report',
  'REORDER_STATUSES': 'Reorder statuses',
  'REPLACED_WORKLOG': 'Replaced Worklog',
  'RESET_LEVELING': 'Reset Leveling',
  'RESIZED_PLAN': 'Resized Plan',
  'RESIZED_WORKLOG': 'Resized Worklog',
  'RESIZED_WORKLOG_IN_CALENDAR_VIEW': 'Resized Worklog in Calendar View',
  'REVERTED_TO_CALCULATED_TIMEFRAME': 'Reverted to Calculated Timeframe',
  'REVERTED_TO_A_SINGLE_BUDGET': 'Reverted to a Single Budget',
  'REVOKED_APPLICATION': 'Revoked Application',
  'ROADMAP_ADDED': 'Roadmap Added',
  'ROADMAP_REMOVED': 'Roadmap Removed',
  'ROADMUNK_LINK': 'Roadmunk link',
  'RUN_LEVELING': 'Run Leveling',
  'SEARCH_DIALOG': 'Search dialog',
  'SELECT_AGGREGATE_MODE': 'Select aggregate mode',
  'SELECT_DEPENDENCIES': 'Select dependencies',
  'SELECT_TEAMS': 'Select teams',
  'SELECTED_GANTT': 'Selected Gantt',
  'SELECTED_ISSUE_FOR_TRACKER': 'Selected Issue For Tracker',
  'SELECTED_PLANNER': 'Selected Planner',
  'SELECTED_PROJECT': 'Selected Project',
  'SELECTED_SPECIFIC_DATES': 'Selected Specific Dates',
  'SELECTED_TEAM': 'Selected Team',
  'SELECTED_FROM_DROPDOWN_MENU': 'Selected from Dropdown Menu',
  'SELECTOR': 'Selector',
  'SET_APPROVER_AS_DEFAULT': 'Set Approver as Default',
  'SET_DEFAULT_TEAM_ROLE': 'Set Default Team Role',
  'SET_PROGRAM_MANAGER': 'Set Program Manager',
  'SET_AS_DEFAULT': 'Set as Default',
  'SET_AS_DEFAULT_WORKSPACE': 'Set as Default Workspace',
  'SET_ESTIMATE_LIMIT': 'Set estimate limit',
  'SET_TO_AUTOMATIC_MODE': 'Set to Automatic Mode',
  'SET_TO_DAILY_SUMMARY_JIRA_WORKLOG_FOR_MULTIPLE_TEMPO_WORKLOGS': 'Set to Daily Summary Jira worklog for multiple Tempo worklogs',
  'SET_TO_ONE_JIRA_WORKLOG_PER_TEMPO_WORKLOG': 'Set to One Jira Worklog per Tempo worklog',
  'SET_TO_REMINDER_MODE': 'Set to Reminder Mode',
  'SET_TO_STANDARD_MODE': 'Set to Standard Mode',
  'SHARE_LINK': 'Share link',
  'SHOW_ACTIVITY_PROVIDER': 'Show Activity Provider',
  'SHOW_CALENDAR_EVENTS': 'Show Calendar Events',
  'SHOW_CAPACITY_INDICATORS': 'Show Capacity Indicators',
  'SHOW_GENERIC_PLANS': 'Show Generic Plans',
  'SHOW_INCOMPLETE_ACTIVITY': 'Show Incomplete Activity',
  'SHOW_ISSUES_SIDE_PANEL': 'Show Issues Side Panel',
  'SHOW_KPI_PANEL': 'Show KPI Panel',
  'SHOW_LARGE_CARDS': 'Show Large Cards',
  'SHOW_REJECTED_ACTIVITY': 'Show Rejected Activity',
  'SHOW_REJECTED_PLANS': 'Show Rejected Plans',
  'SHOW_SKILLS': 'Show Skills',
  'SHOW_WEEKENDS': 'Show Weekends',
  'SHOW_SEARCH_BAR_PANEL': 'Show search bar panel',
  'SHOW_TRANSFORMATION_PANEL': 'Show transformation panel',
  'SORT_BY_START_TIME': 'Sort by Start time',
  'SORT_COLUMN': 'Sort column',
  'SPLIT_PLAN': 'Split Plan',
  'SPLIT_WORKLOG': 'Split Worklog',
  'STARTED_AUTOMATICALLY': 'Started Automatically',
  'STATUS_OVERVIEW': 'Status overview',
  'STORY_POINT_SCHEME_DELETED': 'Story Point Scheme Deleted ',
  'STRUCTURE_WIZARD': 'Structure wizard',
  'SUGGESTED': 'Suggested',
  'SWIMLANE_BETA_DISABLED': 'Swimlane Beta Disabled',
  'SWIMLANE_BETA_ENABLED': 'Swimlane Beta Enabled',
  'SWIPE': 'Swipe',
  'SYNCED_PROJECT_SCOPE': 'Synced Project Scope',
  'SYNCHRONIZE': 'Synchronize',
  'TAG_REMOVED_FROM_PROJECT': 'Tag Removed from Project',
  'TAGS_ADDED_TO_PROJECT': 'Tags Added to Project',
  'TAKE_A_GUIDED_TOUR': 'Take a Guided Tour',
  'TEAM_PROPERTIES_CHANGED': 'Team Properties Changed',
  'TEMPO_PLANNED_TIME_SPEC_CHANGE': 'Tempo planned time spec change',
  'TEMPO_WORKLOG_SPEC_CHANGE': 'Tempo worklog spec change',
  'TEST_RUN_SET_DISPLAY_PARAMS': 'Test run set display params',
  'TEST_RUN_SET_NOTES': 'Test run set notes',
  'TEST_RUN_SET_STATUS': 'Test run set status',
  'TEXT_WRAP_DISABLED': 'Text wrap disabled',
  'TEXT_WRAP_ENABLED': 'Text wrap enabled',
  'TOGGLE_AUTOMATION': 'Toggle automation',
  'TOGGLE_EDIT_MODE': 'Toggle edit mode',
  'TRANSFORMATION_APPLIED': 'Transformation applied',
  'TRANSFORMATION_DISABLED': 'Transformation disabled',
  'TURNED_OFF': 'Turned Off',
  'TURNED_OFF_PORTFOLIO_SHARING': 'Turned Off Portfolio Sharing',
  'TURNED_ON': 'Turned On',
  'TURNED_ON_PORTFOLIO_SHARING': 'Turned On Portfolio Sharing',
  'TURNING_OFF_AUTOMATIC_ENABLEMENT': 'Turning off automatic enablement',
  'TURNING_ON_AUTOMATIC_ENABLEMENT': 'Turning on automatic enablement',
  'TUTORIAL_AND_FEATURES': 'Tutorial and Features',
  'UNDO': 'Undo',
  'UNFAVORITED': 'Unfavorited',
  'UNHIDE_PLANS': 'Unhide Plans',
  'UNPIN': 'Unpin',
  'UNPIN_COLUMN': 'Unpin column',
  'UNPINNED': 'Unpinned',
  'UNPINNED_PORTFOLIO': 'Unpinned Portfolio',
  'UNPINNED_REPORT': 'Unpinned Report',
  'UPDATE': 'Update',
  'UPDATE_AUTO_SYNC_SCOPE_SCHEDULE': 'Update Auto-Sync Scope Schedule',
  'UPDATE_BACKLOG_QUERY_TYPE': 'Update backlog query type',
  'UPDATE_COLUMN': 'Update column',
  'UPDATE_CONFIGURATION': 'Update configuration',
  'UPDATE_MARKER': 'Update marker',
  'UPDATE_STATUS': 'Update status',
  'UPDATE_STRUCTURE': 'Update structure',
  'UPDATED': 'Updated',
  'UPDATED_COLOR': 'Updated Color',
  'UPDATED_DESCRIPTION': 'Updated Description',
  'UPDATED_NAME': 'Updated Name',
  'UPDATED_PROJECT_ATTRIBUTE': 'Updated Project Attribute',
  'UPDATED_SCHEDULING': 'Updated Scheduling',
  'UPDATED_STATUS': 'Updated Status',
  'UPDATED_STORY_POINT': 'Updated Story Point',
  'UPDATED_YEAR_END_DATE': 'Updated Year End Date',
  'UPDATED_IN_FORM': 'Updated in Form',
  'UPDATED_IN_REPORT': 'Updated in Report',
  'URL': 'Url',
  'USE_EXISTING_TEMPLATE': 'Use Existing Template',
  'USED_DRAG_AND_DROP': 'Used Drag and Drop',
  'USER_ACCESS_LEVEL_CHANGED': 'User Access Level Changed',
  'USER_ADDED_TO_SHARING': 'User Added to Sharing',
  'USER_ADDED_TO_SHARING_EDITOR': 'User Added to Sharing - Editor',
  'USER_ADDED_TO_SHARING_VIEWER': 'User Added to Sharing - Viewer',
  'USER_OWNERSHIP_TRANSFERRED': 'User Ownership Transferred',
  'USER_REMOVED_FROM_SHARING': 'User Removed from Sharing',
  'VIEW_ALL_REPORTS': 'View All Reports',
  'VIEW_SETTINGS_CHANGED': 'View settings changed',
  'VIEWED_CAPEX_ACCOUNTS': 'Viewed Capex Accounts',
  'VIEWED_LAST_SYNC_DETAILS': 'Viewed Last Sync Details',
  'VIEWED_OPEX_ACCOUNTS': 'Viewed Opex Accounts',
  'VIEWED_PORTFOLIO_DESCRIPTION': 'Viewed Portfolio Description',
  'WELCOME_SCREEN': 'Welcome screen',
  'WRONG_DURATION': 'Wrong Duration',
  'COPIED_EXPENSE_TO_REVENUE': 'Copied Expense to Revenue',
  'DISABLE_INTERNAL_ISSUES_SUMMARIZATION': 'Disable internal issues summarization ',
  'DISABLE_USERS_CAN_MOVE_WORKLOGS_FOR_NON_LINKED_ACCOUNT': 'Disable users can move worklogs for non-linked account',
  'ENABLE_INTERNAL_ISSUES_SUMMARIZATION': 'Enable internal issues summarization ',
  'ENABLE_USERS_CAN_MOVE_WORKLOGS_FOR_NON_LINKED_ACCOUNT': 'Enable users can move worklogs for non-linked account',
  'CLICKED_APPS_BUTTON_IN_POPUP': 'Clicked Apps Button in Popup',
  'CLICKED_BOOST_PRODUCTIVITY_BUTTON': 'Clicked Boost Productivity Button',
  'USE_TEAM_SPECIFIC_CADENCE': 'Use Team specific Cadence',
  'APPLIED_ROVO_GENERATED_VIEW': 'Applied Rovo generated view',
  'ARCHIVE': 'Archive',
  'UNARCHIVE': 'Unarchive',
  'ARCHIVE_CONTACT': 'Archive Contact',
  'ARCHIVE_CUSTOMER': 'Archive Customer',
  'ARCHIVE_IDEA': 'Archive Idea',
  'ARCHIVE_PRODUCT_AREA': 'Archive Product Area',
  'ATTACHMENT_DELETED': 'Attachment Deleted',
  'COMMENTS_POSTED': 'Comments Posted',
  'CREATE_FORM': 'Create Form',
  'CREATE_IDEA': 'Create Idea',
  'CREATE_PRODUCT_AREA': 'Create Product Area',
  'DELETE_IDEA': 'Delete Idea',
  'DELETED_PRODUCT_AREA': 'Deleted Product Area',
  'EDITED_TITLE': 'Edited title',
  'FIELD_ADDED': 'Field added',
  'FIELD_REMOVED': 'Field removed',
  'GET_STARTED': 'Get Started',
  'GO_TO_IDEAS': 'Go to Ideas',
  'GO_TO_INBOX': 'Go to Inbox',
  'INTERNAL_COMMENTS_POSTED': 'Internal Comments Posted',
  'MADE_FIELD_REQUIRED': 'Made field required',
  'RESTORE': 'Restore',
  'RESTORE_CONTACT': 'Restore Contact',
  'RESTORE_CUSTOMER': 'Restore Customer',
  'RESTORE_IDEA': 'Restore Idea',
  'RESTORED_PRODUCT_AREA': 'Restored Product Area',
  'UPDATE_CUSTOMER': 'Update Customer',
  'UPDATED_CUSTOMER': 'Updated Customer',
  'UPDATED_CUSTOMERS': 'Updated Customers',
  'UPDATED_FEEDBACK': 'Updated Feedback',
  'UPDATED_PRODUCT_AREA': 'Updated Product Area',
  'UPDATED_ROADMAP_ITEMS': 'Updated Roadmap Items',
  'UPLOADED_ATTACHMENT': 'Uploaded Attachment',
  'VIEWED_FEEDBACK_LINK_CLICKED': 'Viewed Feedback Link Clicked',
  'RESTORED': 'restored',
  'CLONED_FROM_GROUP': 'Cloned from Group',
  'CONVERTED_FROM_GROUP': 'Converted from Group',
  'CHANGED_PROJECT_STATUS': 'Changed Project Status',
  'CLICKED_AUTOMATE_TIME_LOGGING': 'Clicked Automate Time Logging ',
  'CLICKED_GOOGLE': 'Clicked Google',
  'CLICKED_O365_CALENDAR': 'Clicked o365 Calendar',
  'INCLUDE_CALENDAR_EVENTS': 'Include Calendar Events',
  'RATE_CALCULATION_UPDATED': 'Rate calculation updated',
  'MANUAL_SORTING_ENABLED': 'Manual Sorting Enabled',
  'OVERWRITE_MANUAL_SORTING': 'Overwrite Manual Sorting',
  'CLICKED_RESOLVE_NOW': 'Clicked Resolve now',
  'APPROVAL_LOG': 'Approval Log',
  'BUILD_YOUR_OWN_ROADMAP': 'Build your own Roadmap',
  'CLICKED_CONTINUE': 'Clicked Continue',
  'DISABLED_SHOW_TEMPO_IN_THE_JIRA_ISSUE_VIEW': 'Disabled Show Tempo in the Jira Issue View',
  'DISMISSED': 'Dismissed',
  'ENABLED_SHOW_TEMPO_IN_THE_JIRA_ISSUE_VIEW': 'Enabled Show Tempo in the Jira Issue View',
  'JOINED_TEAMS_ROADMAP': 'Joined Teams Roadmap',
  'SHOW_FUTURE_PERIODS': 'Show future periods',
  'SHOW_PAST_PERIODS': 'Show past periods',
  'START_FROM_SCRATCH': 'Start from Scratch',
  'USED_SAMPLE_ITEMS': 'Used Sample Items',
  'VIEWED_TEAMS_ROADMAP': 'Viewed Team\'s Roadmap',
  'DRILL_DOWN': 'Drill down',
  'BREAD_CRUMB': 'Bread crumb',
  'NAVIGATION': 'Navigation',
  'UPDATED_FILTER': 'Updated filter',
  'UPDATED_SORTING': 'Updated sorting',
  'CLICKED_ON_WORK_ITEM': 'Clicked on work item',
  'CLICKED_VIEW_DETAILS': 'Clicked view details',
  'CLICKED_FROM_TAKE_ACTION_PANEL': 'Clicked from Take Action panel',
  'CLICKED_ON_PAGE': 'Clicked on page',
  'CLICKED_FROM_SIDE_PANEL': 'Clicked from side panel',
  'OPENED': 'Opened',
  'QUESTION_SUBMITTED': 'Question submitted',
  'OPENED_FROM_WORK_ITEMS': 'Opened from work items',
  'SET_TEAM': 'Set Team',
  'SET_ESTIMATE': 'Set Estimate',
  'SET_PARENT': 'Set Parent',
  'ONBOARDING_CHECKLIST': 'Onboarding checklist',
  'DRILL_DOWN_FROM_SEARCH': 'Drill down from search',
  'BREAD_CRUMB_FROM_SEARCH': 'Bread crumb from search',
} as const;
export type OriginActionType = typeof OriginAction;
export type OriginActionValueType = OriginActionType[keyof OriginActionType];

let sysWebBrowser: any;
let sysWebBrowserVersion: any;
let sysOriginProduct: any;
let sysSegmentSourceType: any;
let sysAppVersion: any;

export function setSystemProperties(properties: {webBrowser: string;
    webBrowserVersion: string;
    originProduct: OriginProductValueType;
    segmentSourceType: SegmentSourceTypeValueType;
    appVersion: string}) {
if (properties.webBrowser !== null && properties.webBrowser !== undefined) {
  sysWebBrowser = properties.webBrowser;
}
if (properties.webBrowserVersion !== null && properties.webBrowserVersion !== undefined) {
  sysWebBrowserVersion = properties.webBrowserVersion;
}
if (properties.originProduct !== null && properties.originProduct !== undefined) {
  sysOriginProduct = properties.originProduct;
}
if (properties.segmentSourceType !== null && properties.segmentSourceType !== undefined) {
  sysSegmentSourceType = properties.segmentSourceType;
}
if (properties.appVersion !== null && properties.appVersion !== undefined) {
  sysAppVersion = properties.appVersion;
}
}

let TempoSPM: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {webBrowser: string;
    webBrowserVersion: string;
    originProduct: OriginProductValueType;
    segmentSourceType: SegmentSourceTypeValueType;
    appVersion: string},
    destinationOptions: any,
    TempoSPMDestination: CustomDestination) {
if (__AVO_ENV__ !== null) {
  return;
}
__AVO_ENV__ = options.env;
if (options.avoLogger !== undefined) {
  __AVO_LOGGER__ = options.avoLogger;
}
if (options.noop === true) {
  __AVO_NOOP__ = true;
}
if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
  InternalAvoLogger.warn("[avo] ****************************************************");
  InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
  InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
  InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
  InternalAvoLogger.warn("[avo] ****************************************************");
  __AVO_NOOP__ = false;
}
if (__AVO_NOOP__) {
  InternalAvoLogger.log("[avo] ****************************************************");
  InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
  InternalAvoLogger.log("[avo] - No events will be sent");
  InternalAvoLogger.log("[avo] - No network requests are made");
  InternalAvoLogger.log("[avo] ****************************************************");
}
if (options.strict !== undefined) {
  __STRICT__ = options.strict !== false;
}
if (options.reportFailureAs !== undefined) {
  __REPORT_FAILURE_AS__ = options.reportFailureAs;
}
__WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
if (!__AVO_NOOP__ && options.inspector !== undefined) {
  __INSPECTOR__ = options.inspector;
} else if (__AVO_ENV__ !== 'prod') {
  InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
}

setSystemProperties(systemProperties);

destinationOptions = destinationOptions || {};

if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
  
}
if (!__AVO_NOOP__) {
  if (__AVO_ENV__ === AvoEnv.Prod) {
}
if (__AVO_ENV__ === AvoEnv.Dev) {
}

TempoSPM = TempoSPMDestination;
if (__AVO_ENV__ === 'prod') {
  TempoSPM && TempoSPM.make && TempoSPM.make(__AVO_ENV__, "KmQbMUXlKnuk5xZqOnOnB5qJbP6VfvGn");
} else if (__AVO_ENV__ === 'dev') {
  TempoSPM && TempoSPM.make && TempoSPM.make(__AVO_ENV__, "9bQbgq69CasXFjqyAgtfv6xN0Palosww");
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Tempo SPM. Head to destination settings in Avo to set a staging key.");
  TempoSPM && TempoSPM.make && TempoSPM.make(__AVO_ENV__, null);
}
if (__AVO_ENV__ === AvoEnv.Dev) {
  // debug console in Avo
  _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
}
}
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
__AVO_LOGGER__ = avoLogger;
}

export interface IdentifiedUserProperties {
  userId_: string;
  userId: string;
  userTimezone: string;
  userContinent: string;
  userLocale: string;
  userRole: string;
  emailUser: string;
  firstLogin: string;
  firstName: string;
  lastLogin: string;
  lastName: string;
  status: string;
  wasInvitedUser: boolean;
  userCountry: string;
  accountMemberNumber: string;
  hasVerifiedEmail: boolean;
  subId: string;
}
/**
 * Identified User: This event is sent when a user is identified.
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.userId: The product backend User ID
 * @param properties.userTimezone: User Timezone (browser)
 * @param properties.userContinent: Name of User Continent
 * @param properties.userLocale: Instance language
 * @param properties.userRole: the permission role of the user
 * @param properties.emailUser: email tied to a user
 * @param properties.firstLogin: date of first login
 * @param properties.firstName: first name of user
 * @param properties.lastLogin: date of last login for the user
 * @param properties.lastName: last name of the user
 * @param properties.status: activity status of the user (e.g. engaged, inactive)
 * @param properties.wasInvitedUser: boolean value for if a user was invited
 * @param properties.userCountry: country of the user
 * @param properties.accountMemberNumber: user indexing based on license joining time; this value will be one for the first user who starts a trial
 * @param properties.hasVerifiedEmail: boolean for if the user has a verified email
 * @param properties.subId: subscription id
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/D_vI8GsYA}
 */
export function identifiedUser(properties: IdentifiedUserProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
userPropertiesArray.push({id: "WrXB4sX-G", name: "user_id", value: properties.userId});
userPropertiesArray.push({id: "pWC73umMS", name: "user_timezone", value: properties.userTimezone});
userPropertiesArray.push({id: "u_btaafHt", name: "user_continent", value: properties.userContinent});
userPropertiesArray.push({id: "EQuG4nG1i", name: "user_locale", value: properties.userLocale});
userPropertiesArray.push({id: "SeHaN7nzr", name: "user_role", value: properties.userRole});
userPropertiesArray.push({id: "PsG9cwcrg", name: "email_user", value: properties.emailUser});
userPropertiesArray.push({id: "ZJgKVlGcP", name: "first_login", value: properties.firstLogin});
userPropertiesArray.push({id: "_bkyM1Kkq", name: "first_name", value: properties.firstName});
userPropertiesArray.push({id: "XL0pgckov", name: "last_login", value: properties.lastLogin});
userPropertiesArray.push({id: "7IfOYbl6I", name: "last_name", value: properties.lastName});
userPropertiesArray.push({id: "-UCTfVhRU", name: "status", value: properties.status});
userPropertiesArray.push({id: "srS5J6Xhx", name: "was_invited_user", value: properties.wasInvitedUser});
userPropertiesArray.push({id: "lKCXYH6qM", name: "user_country", value: properties.userCountry});
userPropertiesArray.push({id: "PXnEsgb9Z", name: "account_member_number", value: properties.accountMemberNumber});
userPropertiesArray.push({id: "UnzMw3FKKm", name: "has_verified_email", value: properties.hasVerifiedEmail});
userPropertiesArray.push({id: "kWkdM4lOh1", name: "sub_id", value: properties.subId});
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "D_vI8GsYA", "5cc4a01bf3c393334c306bf7aa30354df469995541c0b50a8f72a41f67d2357c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Identified User", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("D_vI8GsYA", "Identified User", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  // destination TempoSPM
  TempoSPM.identify(properties.userId_);
  TempoSPM.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
} else {
  // do nothing
}
}

export interface PageViewedProperties {
  customDestinationPageName_: string;
}
/**
 * Page Viewed: Triggered when a user loads a page
 * 
 * @param properties the properties associated with this event
 * @param properties.customDestinationPageName_: Name of the page or screen
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/GvLcC7uRsO}
 */
export function pageViewed(properties: PageViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "GvLcC7uRsO", "d019be412f0ea6fbed5b87788cb196a9c3bb110a0537e1d6facc21a80324c9d6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Page Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("GvLcC7uRsO", "Page Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  // destination TempoSPM
  if (TempoSPM.logPage) {
    TempoSPM.logPage(properties.customDestinationPageName_, (Object as any).assign({}, eventProperties));
} else {
  InternalAvoLogger.error('Page method is not implemented in the destination', '');
}
} else {
  // do nothing
}
}

export interface UserInviteSentProperties {
  roleType: RoleTypeValueType;
}
/**
 * User Invite Sent: Triggered when a user sends an invite to another user (fires on behalf of the user who sent the invite)
 * 
 * @param properties the properties associated with this event
 * @param properties.roleType: the permission role type
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/cvukdjuTmI}
 */
export function userInviteSent(properties: UserInviteSentProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "aCy0nbVNUxzY", name: "role_type", value: properties.roleType});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "cvukdjuTmI", "065cc9c52ce06491e307087cfa8b8b599a07b931a402a03ca027fec6ef71fdfb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("User Invite Sent", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("cvukdjuTmI", "User Invite Sent", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Invite Sent", eventProperties, "cvukdjuTmI", "065cc9c52ce06491e307087cfa8b8b599a07b931a402a03ca027fec6ef71fdfb");
}
// destination TempoSPM
TempoSPM.logEvent("User Invite Sent", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationCreatedProperties {
  instanceBaseUrl: string;
  organizationId: string;
}
/**
 * Organization Created: when a user creates an org
 * 
 * @param properties the properties associated with this event
 * @param properties.instanceBaseUrl: base_url of the instance
 * @param properties.organizationId: unique identifier of an organization(LP)
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/X9sJf7FQHnKeNy0FF7-Mz}
 */
export function organizationCreated(properties: OrganizationCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "idtaCPqFSj", name: "instance_base_url", value: properties.instanceBaseUrl});
eventPropertiesArray.push({id: "WMcrqKNyJ", name: "organization_id", value: properties.organizationId});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "X9sJf7FQHnKeNy0FF7-Mz", "89f11e5a7a66ebe02013b9ea2c43523aa9abf8e18ca82aaa8649fd1755c3ebd8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Organization Created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("X9sJf7FQHnKeNy0FF7-Mz", "Organization Created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
// @ts-ignore
let eventPropertiesTempoSPM: any = {...eventProperties};
eventPropertiesTempoSPM["org_url"] = eventPropertiesTempoSPM["instance_base_url"]
delete eventPropertiesTempoSPM["instance_base_url"]
// @ts-ignore
let userPropertiesTempoSPM: any = {...userProperties};
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Organization Created", eventProperties, "X9sJf7FQHnKeNy0FF7-Mz", "89f11e5a7a66ebe02013b9ea2c43523aa9abf8e18ca82aaa8649fd1755c3ebd8");
}
// destination TempoSPM
TempoSPM.logEvent("Organization Created", (Object as any).assign({}, eventPropertiesTempoSPM));
} else {
  // do nothing
}
}

export interface InsightsDashboardViewedProperties {
  originView: OriginViewValueType;
  filtersApplied: FiltersAppliedValueType[];
  sortedBy: string;
  originAction: OriginActionValueType;
  numberOfLevels: number;
}
/**
 * Insights Dashboard Viewed: When users visits Insights Dashboard 
 * 
 * @param properties the properties associated with this event
 * @param properties.originView: the view the user was on when they logged the time (eg. List, Time)
 * @param properties.filtersApplied: list of all the filter types applied to the report
 * @param properties.sortedBy: name of the column used for sorting
 * @param properties.originAction: how or where the action was initiated (eg. Clicked Add Item Button, Input Value Into Item Table)
 * @param properties.numberOfLevels: how many levels in the hierarchy
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/mx1zPHLLKoGtIduSL59at}
 */
export function insightsDashboardViewed(properties: InsightsDashboardViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: properties.originView});
eventPropertiesArray.push({id: "uj8ARug1FgQ5", name: "filters_applied", value: properties.filtersApplied});
eventPropertiesArray.push({id: "gimWYNrJA", name: "sorted_by", value: properties.sortedBy});
eventPropertiesArray.push({id: "vY1-y8oZMsL2", name: "origin_action", value: properties.originAction});
eventPropertiesArray.push({id: "wPsaQG9BQ", name: "number_of_levels", value: properties.numberOfLevels});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "mx1zPHLLKoGtIduSL59at", "6aabb270ea49514282072b5531d09b051e0d34a96fa543070481053e84d146bd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Insights Dashboard Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("mx1zPHLLKoGtIduSL59at", "Insights Dashboard Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Insights Dashboard Viewed", eventProperties, "mx1zPHLLKoGtIduSL59at", "6aabb270ea49514282072b5531d09b051e0d34a96fa543070481053e84d146bd");
}
// destination TempoSPM
TempoSPM.logEvent("Insights Dashboard Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ItemSearchedProperties {
  originPage: OriginPageValueType;
  originView: OriginViewValueType;
}
/**
 * Item Searched: When users search items
 * 
 * @param properties the properties associated with this event
 * @param properties.originPage: the page the user was on when they performed the action (eg. User Timesheet, JIRA Issue View)
 * @param properties.originView: the view the user was on when they logged the time (eg. List, Time)
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/pdLpZSEIZ9Vjrx20dAOSO}
 */
export function itemSearched(properties: ItemSearchedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "__jqucy_Vx9b", name: "origin_page", value: properties.originPage});
eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: properties.originView});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "pdLpZSEIZ9Vjrx20dAOSO", "a009d159db7d92ac88688edb524206504c9dd78ec9c87b5f7b9b69c640081bdb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Item Searched", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("pdLpZSEIZ9Vjrx20dAOSO", "Item Searched", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Item Searched", eventProperties, "pdLpZSEIZ9Vjrx20dAOSO", "a009d159db7d92ac88688edb524206504c9dd78ec9c87b5f7b9b69c640081bdb");
}
// destination TempoSPM
TempoSPM.logEvent("Item Searched", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface WorkItemViewedProperties {
  originView: OriginViewValueType;
  originAction: OriginActionValueType;
}
/**
 * Work Item Viewed: When users search items
 * 
 * @param properties the properties associated with this event
 * @param properties.originView: the view the user was on when they logged the time (eg. List, Time)
 * @param properties.originAction: how or where the action was initiated (eg. Clicked Add Item Button, Input Value Into Item Table)
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/dnjwkiqI2alJAFxR5z7uZ}
 */
export function workItemViewed(properties: WorkItemViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: properties.originView});
eventPropertiesArray.push({id: "vY1-y8oZMsL2", name: "origin_action", value: properties.originAction});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "dnjwkiqI2alJAFxR5z7uZ", "43e1bc308dad68bcb0ccfe68228b386cdee38c4b8cf76abcbedda403d8908d5e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Work Item Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("dnjwkiqI2alJAFxR5z7uZ", "Work Item Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Work Item Viewed", eventProperties, "dnjwkiqI2alJAFxR5z7uZ", "43e1bc308dad68bcb0ccfe68228b386cdee38c4b8cf76abcbedda403d8908d5e");
}
// destination TempoSPM
TempoSPM.logEvent("Work Item Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TakeActionPanelViewedProperties {
  originView: OriginViewValueType | null | undefined;
  originAction: OriginActionValueType;
  panelName: PanelNameValueType;
}
/**
 * Take Action Panel Viewed: When users view Take Action panel
 * 
 * @param properties the properties associated with this event
 * @param properties.originView: the view the user was on when they logged the time (eg. List, Time)
 * @param properties.originAction: how or where the action was initiated (eg. Clicked Add Item Button, Input Value Into Item Table)
 * @param properties.panelName: indicates if this is within the left or right panel in the structure
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/nfQeL5HkbNgaa8tkdp5DD}
 */
export function takeActionPanelViewed(properties: TakeActionPanelViewedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.originView !== undefined && properties.originView !== null ?
  eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: properties.originView}) :
  eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: null});
eventPropertiesArray.push({id: "vY1-y8oZMsL2", name: "origin_action", value: properties.originAction});
eventPropertiesArray.push({id: "Nc1YndWQO", name: "panel_name", value: properties.panelName});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "nfQeL5HkbNgaa8tkdp5DD", "a755fe6209b9240b32e4d5b8f7a93d3cb75c28f9135c7436bc3c56e5e9613b84", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Take Action Panel Viewed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("nfQeL5HkbNgaa8tkdp5DD", "Take Action Panel Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Take Action Panel Viewed", eventProperties, "nfQeL5HkbNgaa8tkdp5DD", "a755fe6209b9240b32e4d5b8f7a93d3cb75c28f9135c7436bc3c56e5e9613b84");
}
// destination TempoSPM
TempoSPM.logEvent("Take Action Panel Viewed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AskAIInteractedProperties {
  originAction: OriginActionValueType;
  isSuggestion: boolean;
  feedbackType: string;
  hasComment: boolean;
}
/**
 * Ask AI Interacted: When users interact with Ask AI button
 * 
 * @param properties the properties associated with this event
 * @param properties.originAction: how or where the action was initiated (eg. Clicked Add Item Button, Input Value Into Item Table)
 * @param properties.isSuggestion: suggested : Boolean
 * @param properties.feedbackType: no description
 * @param properties.hasComment: when users add comments
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/3VZVkj5bmIc_mhuZ7TFJP}
 */
export function askAiInteracted(properties: AskAIInteractedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "vY1-y8oZMsL2", name: "origin_action", value: properties.originAction});
eventPropertiesArray.push({id: "qZ7ouIqCa7a3YI9FI7-JP", name: "is_suggestion", value: properties.isSuggestion});
eventPropertiesArray.push({id: "MTikcQ1fss5AiUDJMbVWK", name: "feedback_type", value: properties.feedbackType});
eventPropertiesArray.push({id: "2rDrlM_JZVQX5GDZbDHSL", name: "has_comment", value: properties.hasComment});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3VZVkj5bmIc_mhuZ7TFJP", "ed8f26eaff5859905daeb26cbaa3deb4336ed9e5c8641083d99ed7121cb1d6a8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Ask AI Interacted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3VZVkj5bmIc_mhuZ7TFJP", "Ask AI Interacted", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Ask AI Interacted", eventProperties, "3VZVkj5bmIc_mhuZ7TFJP", "ed8f26eaff5859905daeb26cbaa3deb4336ed9e5c8641083d99ed7121cb1d6a8");
}
// destination TempoSPM
TempoSPM.logEvent("Ask AI Interacted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface WorkItemUpdatedProperties {
  originAction: OriginActionValueType;
  originPage: OriginPageValueType;
  panelName: PanelNameValueType | null | undefined;
  originView: OriginViewValueType | null | undefined;
}
/**
 * Work Item Updated: When users update work items
 * 
 * @param properties the properties associated with this event
 * @param properties.originAction: how or where the action was initiated (eg. Clicked Add Item Button, Input Value Into Item Table)
 * @param properties.originPage: the page the user was on when they performed the action (eg. User Timesheet, JIRA Issue View)
 * @param properties.panelName: indicates if this is within the left or right panel in the structure
 * @param properties.originView: the view the user was on when they logged the time (eg. List, Time)
 * 
 * @see {@link https://www.avo.app/schemas/7JBjRhWGgpbREMm61E1Y/branches/-Tp80h5X89GUCAgNBTyi5/events/kdRjhJ2JcWdj1DVrwYU7T}
 */
export function workItemUpdated(properties: WorkItemUpdatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "vY1-y8oZMsL2", name: "origin_action", value: properties.originAction});
eventPropertiesArray.push({id: "__jqucy_Vx9b", name: "origin_page", value: properties.originPage});
properties.panelName !== undefined && properties.panelName !== null ?
  eventPropertiesArray.push({id: "Nc1YndWQO", name: "panel_name", value: properties.panelName}) :
  eventPropertiesArray.push({id: "Nc1YndWQO", name: "panel_name", value: null});
properties.originView !== undefined && properties.originView !== null ?
  eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: properties.originView}) :
  eventPropertiesArray.push({id: "MxxnnG6E37aZ", name: "origin_view", value: null});
eventPropertiesArray.push({id: "RN83SIqkD", name: "web_browser", value: sysWebBrowser});
eventPropertiesArray.push({id: "J1ceb84St", name: "web_browser_version", value: sysWebBrowserVersion});
eventPropertiesArray.push({id: "Vdkm1SlEt-", name: "origin_product", value: sysOriginProduct});
eventPropertiesArray.push({id: "0fvMyarba", name: "segment_source_type", value: sysSegmentSourceType});
eventPropertiesArray.push({id: "is32Bn3QNR", name: "app_version", value: sysAppVersion});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "kdRjhJ2JcWdj1DVrwYU7T", "5c9b81fb4183e316b395962811a0f60d747066cb3b974c68c1c254d68b277190", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("Work Item Updated", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("kdRjhJ2JcWdj1DVrwYU7T", "Work Item Updated", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Work Item Updated", eventProperties, "kdRjhJ2JcWdj1DVrwYU7T", "5c9b81fb4183e316b395962811a0f60d747066cb3b974c68c1c254d68b277190");
}
// destination TempoSPM
TempoSPM.logEvent("Work Item Updated", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  SegmentSourceType,
  OriginView,
  PanelName,
  OriginProduct,
  OriginPage,
  RoleType,
  FiltersApplied,
  OriginAction,
  identifiedUser,
  pageViewed,
  userInviteSent,
  organizationCreated,
  insightsDashboardViewed,
  itemSearched,
  workItemViewed,
  takeActionPanelViewed,
  askAiInteracted,
  workItemUpdated,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["identifiedUser","pageViewed","userInviteSent","organizationCreated","insightsDashboardViewed","itemSearched","workItemViewed","takeActionPanelViewed","askAiInteracted","workItemUpdated"]
